var EventTypeCodes;

(function (EventTypeCodes) {
  EventTypeCodes[EventTypeCodes["None"] = 0] = "None";
  EventTypeCodes[EventTypeCodes["Collector"] = 10] = "Collector";
  EventTypeCodes[EventTypeCodes["ComDevice"] = 26] = "ComDevice";
  EventTypeCodes[EventTypeCodes["DAPDevice"] = 1] = "DAPDevice";
  EventTypeCodes[EventTypeCodes["DERDevice"] = 2] = "DERDevice";
  EventTypeCodes[EventTypeCodes["DSPDevice"] = 6] = "DSPDevice";
  EventTypeCodes[EventTypeCodes["ElectricMeter"] = 3] = "ElectricMeter";
  EventTypeCodes[EventTypeCodes["ElectricVehicle"] = 58] = "ElectricVehicle";
  EventTypeCodes[EventTypeCodes["EnergyRouter"] = 23] = "EnergyRouter";
  EventTypeCodes[EventTypeCodes["Feeder"] = 13] = "Feeder";
  EventTypeCodes[EventTypeCodes["GasMeter"] = 4] = "GasMeter";
  EventTypeCodes[EventTypeCodes["Gateway"] = 5] = "Gateway";
  EventTypeCodes[EventTypeCodes["Generator"] = 14] = "Generator";
  EventTypeCodes[EventTypeCodes["InPremisesDisplay"] = 15] = "InPremisesDisplay";
  EventTypeCodes[EventTypeCodes["LoadControlDevice"] = 16] = "LoadControlDevice";
  EventTypeCodes[EventTypeCodes["NetworkRouter"] = 11] = "NetworkRouter";
  EventTypeCodes[EventTypeCodes["PANDevice"] = 12] = "PANDevice";
  EventTypeCodes[EventTypeCodes["PANGateway"] = 7] = "PANGateway";
  EventTypeCodes[EventTypeCodes["PANMeter"] = 17] = "PANMeter";
  EventTypeCodes[EventTypeCodes["PrepaymentTerminal"] = 18] = "PrepaymentTerminal";
  EventTypeCodes[EventTypeCodes["ProgCtlThermostat"] = 19] = "ProgCtlThermostat";
  EventTypeCodes[EventTypeCodes["RangeExtender"] = 20] = "RangeExtender";
  EventTypeCodes[EventTypeCodes["Regulator"] = 21] = "Regulator";
  EventTypeCodes[EventTypeCodes["Substation"] = 22] = "Substation";
  EventTypeCodes[EventTypeCodes["Transformer"] = 8] = "Transformer";
  EventTypeCodes[EventTypeCodes["WasteWaterMeter"] = 25] = "WasteWaterMeter";
  EventTypeCodes[EventTypeCodes["WaterMeter"] = 24] = "WaterMeter";
  EventTypeCodes[EventTypeCodes["MDM"] = 101] = "MDM";
  EventTypeCodes[EventTypeCodes["Device"] = 102] = "Device";
})(EventTypeCodes || (EventTypeCodes = {}));

var EndDeviceEventTypeCodes = EventTypeCodes;

var DomainCodes;

(function (DomainCodes) {
  DomainCodes[DomainCodes["None"] = 0] = "None";
  DomainCodes[DomainCodes["AssociatedDevice"] = 39] = "AssociatedDevice";
  DomainCodes[DomainCodes["Battery"] = 2] = "Battery";
  DomainCodes[DomainCodes["Billing"] = 20] = "Billing";
  DomainCodes[DomainCodes["Cartridge"] = 3] = "Cartridge";
  DomainCodes[DomainCodes["Clock"] = 36] = "Clock";
  DomainCodes[DomainCodes["Communication"] = 1] = "Communication";
  DomainCodes[DomainCodes["Configuration"] = 7] = "Configuration";
  DomainCodes[DomainCodes["Demand"] = 8] = "Demand";
  DomainCodes[DomainCodes["Firmware"] = 11] = "Firmware";
  DomainCodes[DomainCodes["GasSupply"] = 4] = "GasSupply";
  DomainCodes[DomainCodes["Installation"] = 6] = "Installation";
  DomainCodes[DomainCodes["KYZPulseCounter"] = 38] = "KYZPulseCounter";
  DomainCodes[DomainCodes["LoadControl"] = 15] = "LoadControl";
  DomainCodes[DomainCodes["LoadProfile"] = 16] = "LoadProfile";
  DomainCodes[DomainCodes["Logs"] = 17] = "Logs";
  DomainCodes[DomainCodes["Memory"] = 18] = "Memory";
  DomainCodes[DomainCodes["Metrology"] = 21] = "Metrology";
  DomainCodes[DomainCodes["MobileSecurity"] = 14] = "MobileSecurity";
  DomainCodes[DomainCodes["Modem"] = 19] = "Modem";
  DomainCodes[DomainCodes["ModuleFirmware"] = 9] = "ModuleFirmware";
  DomainCodes[DomainCodes["Network"] = 23] = "Network";
  DomainCodes[DomainCodes["Pairing"] = 10] = "Pairing";
  DomainCodes[DomainCodes["Power"] = 26] = "Power";
  DomainCodes[DomainCodes["Pressure"] = 29] = "Pressure";
  DomainCodes[DomainCodes["RCDSwitch"] = 31] = "RCDSwitch";
  DomainCodes[DomainCodes["Recoder"] = 41] = "Recoder";
  DomainCodes[DomainCodes["Security"] = 12] = "Security";
  DomainCodes[DomainCodes["Temperature"] = 35] = "Temperature";
  DomainCodes[DomainCodes["VideoDisplay"] = 13] = "VideoDisplay";
  DomainCodes[DomainCodes["Volume"] = 40] = "Volume";
  DomainCodes[DomainCodes["Watchdog"] = 37] = "Watchdog";
  DomainCodes[DomainCodes["WaterSupply"] = 5] = "WaterSupply";
})(DomainCodes || (DomainCodes = {}));

var EndDeviceDomainCodes = DomainCodes;

var SubDomainCodes;

(function (SubDomainCodes) {
  SubDomainCodes[SubDomainCodes["None"] = 0] = "None";
  SubDomainCodes[SubDomainCodes["Access"] = 1] = "Access";
  SubDomainCodes[SubDomainCodes["Activation"] = 283] = "Activation";
  SubDomainCodes[SubDomainCodes["AlarmTable"] = 285] = "AlarmTable";
  SubDomainCodes[SubDomainCodes["ADConverter"] = 142] = "ADConverter";
  SubDomainCodes[SubDomainCodes["AllEvents"] = 148] = "AllEvents";
  SubDomainCodes[SubDomainCodes["ApparentPower"] = 290] = "ApparentPower";
  SubDomainCodes[SubDomainCodes["Allocation"] = 2] = "Allocation";
  SubDomainCodes[SubDomainCodes["Association"] = 74] = "Association";
  SubDomainCodes[SubDomainCodes["AUTDProcess"] = 3] = "AUTDProcess";
  SubDomainCodes[SubDomainCodes["AutoRegistration"] = 5] = "AutoRegistration";
  SubDomainCodes[SubDomainCodes["AutoTime"] = 7] = "AutoTime";
  SubDomainCodes[SubDomainCodes["BTU"] = 13] = "BTU";
  SubDomainCodes[SubDomainCodes["Buffer"] = 14] = "Buffer";
  SubDomainCodes[SubDomainCodes["Cable"] = 15] = "Cable";
  SubDomainCodes[SubDomainCodes["Calculation"] = 16] = "Calculation";
  SubDomainCodes[SubDomainCodes["Calibration"] = 18] = "Calibration";
  SubDomainCodes[SubDomainCodes["Certificate"] = 21] = "Certificate";
  SubDomainCodes[SubDomainCodes["Charge"] = 22] = "Charge";
  SubDomainCodes[SubDomainCodes["Checksum"] = 284] = "Checksum";
  SubDomainCodes[SubDomainCodes["Concentration"] = 39] = "Concentration";
  SubDomainCodes[SubDomainCodes["Constants"] = 23] = "Constants";
  SubDomainCodes[SubDomainCodes["ControlPoint"] = 26] = "ControlPoint";
  SubDomainCodes[SubDomainCodes["Cover"] = 29] = "Cover";
  SubDomainCodes[SubDomainCodes["CRC"] = 30] = "CRC";
  SubDomainCodes[SubDomainCodes["Credit"] = 8] = "Credit";
  SubDomainCodes[SubDomainCodes["Current"] = 6] = "Current";
  SubDomainCodes[SubDomainCodes["Data"] = 31] = "Data";
  SubDomainCodes[SubDomainCodes["DataLog"] = 33] = "DataLog";
  SubDomainCodes[SubDomainCodes["Date"] = 34] = "Date";
  SubDomainCodes[SubDomainCodes["Day"] = 35] = "Day";
  SubDomainCodes[SubDomainCodes["DaylightSavingsTime"] = 56] = "DaylightSavingsTime";
  SubDomainCodes[SubDomainCodes["DayLimit"] = 299] = "DayLimit";
  SubDomainCodes[SubDomainCodes["Decryption"] = 36] = "Decryption";
  SubDomainCodes[SubDomainCodes["Display"] = 143] = "Display";
  SubDomainCodes[SubDomainCodes["Door"] = 128] = "Door";
  SubDomainCodes[SubDomainCodes["EmergencySupplyCapacityLimit"] = 138] = "EmergencySupplyCapacityLimit";
  SubDomainCodes[SubDomainCodes["Encoder"] = 40] = "Encoder";
  SubDomainCodes[SubDomainCodes["EncoderRegister"] = 41] = "EncoderRegister";
  SubDomainCodes[SubDomainCodes["EPROM"] = 42] = "EPROM";
  SubDomainCodes[SubDomainCodes["Event"] = 43] = "Event";
  SubDomainCodes[SubDomainCodes["EventLog"] = 44] = "EventLog";
  SubDomainCodes[SubDomainCodes["EWM"] = 45] = "EWM";
  SubDomainCodes[SubDomainCodes["Feature"] = 46] = "Feature";
  SubDomainCodes[SubDomainCodes["FirmwareReset"] = 47] = "FirmwareReset";
  SubDomainCodes[SubDomainCodes["Flow"] = 48] = "Flow";
  SubDomainCodes[SubDomainCodes["FPV"] = 49] = "FPV";
  SubDomainCodes[SubDomainCodes["Frames"] = 50] = "Frames";
  SubDomainCodes[SubDomainCodes["Frequency"] = 4] = "Frequency";
  SubDomainCodes[SubDomainCodes["GCAnalyzer"] = 51] = "GCAnalyzer";
  SubDomainCodes[SubDomainCodes["HeadEndSystem"] = 52] = "HeadEndSystem";
  SubDomainCodes[SubDomainCodes["HistoryLog"] = 53] = "HistoryLog";
  SubDomainCodes[SubDomainCodes["HMAC"] = 54] = "HMAC";
  SubDomainCodes[SubDomainCodes["Holiday"] = 97] = "Holiday";
  SubDomainCodes[SubDomainCodes["Identity"] = 10] = "Identity";
  SubDomainCodes[SubDomainCodes["Initialisation"] = 298] = "Initialisation";
  SubDomainCodes[SubDomainCodes["Input"] = 55] = "Input";
  SubDomainCodes[SubDomainCodes["InstallDate"] = 57] = "InstallDate";
  SubDomainCodes[SubDomainCodes["IntelligentRegister"] = 58] = "IntelligentRegister";
  SubDomainCodes[SubDomainCodes["Interval"] = 59] = "Interval";
  SubDomainCodes[SubDomainCodes["IO"] = 60] = "IO";
  SubDomainCodes[SubDomainCodes["IPAddress"] = 127] = "IPAddress";
  SubDomainCodes[SubDomainCodes["LANAddress"] = 61] = "LANAddress";
  SubDomainCodes[SubDomainCodes["LastRead"] = 62] = "LastRead";
  SubDomainCodes[SubDomainCodes["List"] = 63] = "List";
  SubDomainCodes[SubDomainCodes["ListPointers"] = 64] = "ListPointers";
  SubDomainCodes[SubDomainCodes["Login"] = 65] = "Login";
  SubDomainCodes[SubDomainCodes["LowSpeedBus"] = 145] = "LowSpeedBus";
  SubDomainCodes[SubDomainCodes["MagneticSwitch"] = 66] = "MagneticSwitch";
  SubDomainCodes[SubDomainCodes["MaintMode"] = 11] = "MaintMode";
  SubDomainCodes[SubDomainCodes["Measurement"] = 67] = "Measurement";
  SubDomainCodes[SubDomainCodes["MeasurementType"] = 286] = "MeasurementType";
  SubDomainCodes[SubDomainCodes["Mesh"] = 68] = "Mesh";
  SubDomainCodes[SubDomainCodes["MeterBus"] = 147] = "MeterBus";
  SubDomainCodes[SubDomainCodes["MeteringMode"] = 12] = "MeteringMode";
  SubDomainCodes[SubDomainCodes["Mobile"] = 69] = "Mobile";
  SubDomainCodes[SubDomainCodes["MOL_PERCENT"] = 70] = "MOL_PERCENT";
  SubDomainCodes[SubDomainCodes["NetworkId"] = 71] = "NetworkId";
  SubDomainCodes[SubDomainCodes["NeutralCurrent"] = 137] = "NeutralCurrent";
  SubDomainCodes[SubDomainCodes["NVRAM"] = 72] = "NVRAM";
  SubDomainCodes[SubDomainCodes["OptionBoard"] = 146] = "OptionBoard";
  SubDomainCodes[SubDomainCodes["Parameter"] = 75] = "Parameter";
  SubDomainCodes[SubDomainCodes["ParentDevice"] = 76] = "ParentDevice";
  SubDomainCodes[SubDomainCodes["Parity"] = 77] = "Parity";
  SubDomainCodes[SubDomainCodes["Password"] = 24] = "Password";
  SubDomainCodes[SubDomainCodes["Phase"] = 25] = "Phase";
  SubDomainCodes[SubDomainCodes["PhaseAngle"] = 130] = "PhaseAngle";
  SubDomainCodes[SubDomainCodes["PhaseA"] = 126] = "PhaseA";
  SubDomainCodes[SubDomainCodes["PhaseAApparentPower"] = 291] = "PhaseAApparentPower";
  SubDomainCodes[SubDomainCodes["PhaseACurrent"] = 287] = "PhaseACurrent";
  SubDomainCodes[SubDomainCodes["PhaseAReactivePower"] = 295] = "PhaseAReactivePower";
  SubDomainCodes[SubDomainCodes["PhaseAVoltage"] = 131] = "PhaseAVoltage";
  SubDomainCodes[SubDomainCodes["PhaseAVoltagePotential"] = 126] = "PhaseAVoltagePotential";
  SubDomainCodes[SubDomainCodes["PhaseB"] = 134] = "PhaseB";
  SubDomainCodes[SubDomainCodes["PhaseBApparentPower"] = 292] = "PhaseBApparentPower";
  SubDomainCodes[SubDomainCodes["PhaseBCurrent"] = 288] = "PhaseBCurrent";
  SubDomainCodes[SubDomainCodes["PhaseBReactivePower"] = 296] = "PhaseBReactivePower";
  SubDomainCodes[SubDomainCodes["PhaseBVoltage"] = 132] = "PhaseBVoltage";
  SubDomainCodes[SubDomainCodes["PhaseBVoltagePotential"] = 134] = "PhaseBVoltagePotential";
  SubDomainCodes[SubDomainCodes["PhaseC"] = 135] = "PhaseC";
  SubDomainCodes[SubDomainCodes["PhaseCApparentPower"] = 293] = "PhaseCApparentPower";
  SubDomainCodes[SubDomainCodes["PhaseCCurrent"] = 289] = "PhaseCCurrent";
  SubDomainCodes[SubDomainCodes["PhaseCReactivePower"] = 297] = "PhaseCReactivePower";
  SubDomainCodes[SubDomainCodes["PhaseCVoltage"] = 133] = "PhaseCVoltage";
  SubDomainCodes[SubDomainCodes["PhaseCVoltagePotential"] = 135] = "PhaseCVoltagePotential";
  SubDomainCodes[SubDomainCodes["PhaseSequence"] = 78] = "PhaseSequence";
  SubDomainCodes[SubDomainCodes["PhaseVoltage"] = 79] = "PhaseVoltage";
  SubDomainCodes[SubDomainCodes["PowerFactor"] = 27] = "PowerFactor";
  SubDomainCodes[SubDomainCodes["PowerQuality"] = 28] = "PowerQuality";
  SubDomainCodes[SubDomainCodes["PowerQualityRecording"] = 80] = "PowerQualityRecording";
  SubDomainCodes[SubDomainCodes["PrepaymentCredit"] = 81] = "PrepaymentCredit";
  SubDomainCodes[SubDomainCodes["Pricing"] = 9] = "Pricing";
  SubDomainCodes[SubDomainCodes["Processor"] = 82] = "Processor";
  SubDomainCodes[SubDomainCodes["Program"] = 83] = "Program";
  SubDomainCodes[SubDomainCodes["Pulse"] = 84] = "Pulse";
  SubDomainCodes[SubDomainCodes["Queue"] = 197] = "Queue";
  SubDomainCodes[SubDomainCodes["Radio"] = 136] = "Radio";
  SubDomainCodes[SubDomainCodes["RAM"] = 85] = "RAM";
  SubDomainCodes[SubDomainCodes["Rate"] = 86] = "Rate";
  SubDomainCodes[SubDomainCodes["ReadAccess"] = 202] = "ReadAccess";
  SubDomainCodes[SubDomainCodes["Readings"] = 87] = "Readings";
  SubDomainCodes[SubDomainCodes["ReactivePower"] = 294] = "ReactivePower";
  SubDomainCodes[SubDomainCodes["Recoder"] = 300] = "Recoder";
  SubDomainCodes[SubDomainCodes["Recovery"] = 88] = "Recovery";
  SubDomainCodes[SubDomainCodes["Register"] = 89] = "Register";
  SubDomainCodes[SubDomainCodes["Registration"] = 90] = "Registration";
  SubDomainCodes[SubDomainCodes["Relay"] = 91] = "Relay";
  SubDomainCodes[SubDomainCodes["RemoteAccess"] = 211] = "RemoteAccess";
  SubDomainCodes[SubDomainCodes["ROM"] = 92] = "ROM";
  SubDomainCodes[SubDomainCodes["Rotation"] = 93] = "Rotation";
  SubDomainCodes[SubDomainCodes["RTP"] = 94] = "RTP";
  SubDomainCodes[SubDomainCodes["Schedule"] = 95] = "Schedule";
  SubDomainCodes[SubDomainCodes["Season"] = 228] = "Season";
  SubDomainCodes[SubDomainCodes["SecondaryCredit"] = 96] = "SecondaryCredit";
  SubDomainCodes[SubDomainCodes["SecuredRegister"] = 98] = "SecuredRegister";
  SubDomainCodes[SubDomainCodes["SecuredTable"] = 99] = "SecuredTable";
  SubDomainCodes[SubDomainCodes["SecurityKey"] = 32] = "SecurityKey";
  SubDomainCodes[SubDomainCodes["SecurityKeyLength"] = 119] = "SecurityKeyLength";
  SubDomainCodes[SubDomainCodes["SecurityKeyVersion"] = 120] = "SecurityKeyVersion";
  SubDomainCodes[SubDomainCodes["SelfRead"] = 231] = "SelfRead";
  SubDomainCodes[SubDomainCodes["SelfTest"] = 100] = "SelfTest";
  SubDomainCodes[SubDomainCodes["Sensor"] = 144] = "Sensor";
  SubDomainCodes[SubDomainCodes["Session"] = 129] = "Session";
  SubDomainCodes[SubDomainCodes["SetPoint"] = 101] = "SetPoint";
  SubDomainCodes[SubDomainCodes["SigmaticMessage"] = 102] = "SigmaticMessage";
  SubDomainCodes[SubDomainCodes["Signature"] = 103] = "Signature";
  SubDomainCodes[SubDomainCodes["SignatureLength"] = 104] = "SignatureLength";
  SubDomainCodes[SubDomainCodes["SignatureTimestamp"] = 105] = "SignatureTimestamp";
  SubDomainCodes[SubDomainCodes["SignatureUsage"] = 106] = "SignatureUsage";
  SubDomainCodes[SubDomainCodes["SpecificGravity"] = 240] = "SpecificGravity";
  SubDomainCodes[SubDomainCodes["StandardTime"] = 107] = "StandardTime";
  SubDomainCodes[SubDomainCodes["StandbyMode"] = 108] = "StandbyMode";
  SubDomainCodes[SubDomainCodes["Status"] = 17] = "Status";
  SubDomainCodes[SubDomainCodes["Storage"] = 109] = "Storage";
  SubDomainCodes[SubDomainCodes["SupplyCapacityLimit"] = 139] = "SupplyCapacityLimit";
  SubDomainCodes[SubDomainCodes["Table"] = 110] = "Table";
  SubDomainCodes[SubDomainCodes["Tariff"] = 140] = "Tariff";
  SubDomainCodes[SubDomainCodes["Test"] = 111] = "Test";
  SubDomainCodes[SubDomainCodes["TestMode"] = 19] = "TestMode";
  SubDomainCodes[SubDomainCodes["TextMessage"] = 112] = "TextMessage";
  SubDomainCodes[SubDomainCodes["Threshold"] = 261] = "Threshold";
  SubDomainCodes[SubDomainCodes["Tier"] = 113] = "Tier";
  SubDomainCodes[SubDomainCodes["Time"] = 114] = "Time";
  SubDomainCodes[SubDomainCodes["Timeout"] = 125] = "Timeout";
  SubDomainCodes[SubDomainCodes["TimeReset"] = 115] = "TimeReset";
  SubDomainCodes[SubDomainCodes["TimeSync"] = 116] = "TimeSync";
  SubDomainCodes[SubDomainCodes["TimeVariance"] = 117] = "TimeVariance";
  SubDomainCodes[SubDomainCodes["TimeZone"] = 118] = "TimeZone";
  SubDomainCodes[SubDomainCodes["TOU"] = 121] = "TOU";
  SubDomainCodes[SubDomainCodes["Tranceiver"] = 122] = "Tranceiver";
  SubDomainCodes[SubDomainCodes["Usage"] = 123] = "Usage";
  SubDomainCodes[SubDomainCodes["Version"] = 124] = "Version";
  SubDomainCodes[SubDomainCodes["Voltage"] = 38] = "Voltage";
  SubDomainCodes[SubDomainCodes["Window"] = 73] = "Window";
  SubDomainCodes[SubDomainCodes["WriteAccess"] = 282] = "WriteAccess";
})(SubDomainCodes || (SubDomainCodes = {}));

var EndDeviceSubDomainCodes = SubDomainCodes;

var EventOrActionCodes;

(function (EventOrActionCodes) {
  EventOrActionCodes[EventOrActionCodes["None"] = 0] = "None";
  EventOrActionCodes[EventOrActionCodes["Aborted"] = 1] = "Aborted";
  EventOrActionCodes[EventOrActionCodes["Accessed"] = 2] = "Accessed";
  EventOrActionCodes[EventOrActionCodes["Acknowledged"] = 3] = "Acknowledged";
  EventOrActionCodes[EventOrActionCodes["Activated"] = 4] = "Activated";
  EventOrActionCodes[EventOrActionCodes["AlmostFull"] = 283] = "AlmostFull";
  EventOrActionCodes[EventOrActionCodes["ArmedForClosure"] = 11] = "ArmedForClosure";
  EventOrActionCodes[EventOrActionCodes["ArmedForOpen"] = 12] = "ArmedForOpen";
  EventOrActionCodes[EventOrActionCodes["ArmForClosure"] = 5] = "ArmForClosure";
  EventOrActionCodes[EventOrActionCodes["ArmForClosureFailed"] = 226] = "ArmForClosureFailed";
  EventOrActionCodes[EventOrActionCodes["ArmForOpen"] = 6] = "ArmForOpen";
  EventOrActionCodes[EventOrActionCodes["ArmForOpenFailed"] = 222] = "ArmForOpenFailed";
  EventOrActionCodes[EventOrActionCodes["Attempted"] = 7] = "Attempted";
  EventOrActionCodes[EventOrActionCodes["Calculated"] = 21] = "Calculated";
  EventOrActionCodes[EventOrActionCodes["Cancel"] = 8] = "Cancel";
  EventOrActionCodes[EventOrActionCodes["CancelFailed"] = 86] = "CancelFailed";
  EventOrActionCodes[EventOrActionCodes["Cancelled"] = 10] = "Cancelled";
  EventOrActionCodes[EventOrActionCodes["Change"] = 13] = "Change";
  EventOrActionCodes[EventOrActionCodes["Changed"] = 24] = "Changed";
  EventOrActionCodes[EventOrActionCodes["ChangedOut"] = 284] = "ChangedOut";
  EventOrActionCodes[EventOrActionCodes["ChangeOutRequired"] = 27] = "ChangeOutRequired";
  EventOrActionCodes[EventOrActionCodes["ChangePending"] = 14] = "ChangePending";
  EventOrActionCodes[EventOrActionCodes["Charged"] = 15] = "Charged";
  EventOrActionCodes[EventOrActionCodes["Cleared"] = 28] = "Cleared";
  EventOrActionCodes[EventOrActionCodes["Close"] = 299] = "Close";
  EventOrActionCodes[EventOrActionCodes["Closed"] = 16] = "Closed";
  EventOrActionCodes[EventOrActionCodes["ColdStarted"] = 31] = "ColdStarted";
  EventOrActionCodes[EventOrActionCodes["Confirmed"] = 17] = "Confirmed";
  EventOrActionCodes[EventOrActionCodes["Connect"] = 18] = "Connect";
  EventOrActionCodes[EventOrActionCodes["Connected"] = 42] = "Connected";
  EventOrActionCodes[EventOrActionCodes["ConnectFailed"] = 67] = "ConnectFailed";
  EventOrActionCodes[EventOrActionCodes["Corrupted"] = 43] = "Corrupted";
  EventOrActionCodes[EventOrActionCodes["CorruptionCleared"] = 281] = "CorruptionCleared";
  EventOrActionCodes[EventOrActionCodes["Create"] = 82] = "Create";
  EventOrActionCodes[EventOrActionCodes["Created"] = 83] = "Created";
  EventOrActionCodes[EventOrActionCodes["CreateFailed"] = 297] = "CreateFailed";
  EventOrActionCodes[EventOrActionCodes["CrossPhaseCleared"] = 70] = "CrossPhaseCleared";
  EventOrActionCodes[EventOrActionCodes["CrossPhaseDetected"] = 45] = "CrossPhaseDetected";
  EventOrActionCodes[EventOrActionCodes["Deactivated"] = 19] = "Deactivated";
  EventOrActionCodes[EventOrActionCodes["Decreased"] = 57] = "Decreased";
  EventOrActionCodes[EventOrActionCodes["Delayed"] = 20] = "Delayed";
  EventOrActionCodes[EventOrActionCodes["Disable"] = 22] = "Disable";
  EventOrActionCodes[EventOrActionCodes["Disabled"] = 66] = "Disabled";
  EventOrActionCodes[EventOrActionCodes["DisableFailed"] = 220] = "DisableFailed";
  EventOrActionCodes[EventOrActionCodes["Disallowed"] = 161] = "Disallowed";
  EventOrActionCodes[EventOrActionCodes["Disconnect"] = 23] = "Disconnect";
  EventOrActionCodes[EventOrActionCodes["Disconnected"] = 68] = "Disconnected";
  EventOrActionCodes[EventOrActionCodes["DisconnectFailed"] = 84] = "DisconnectFailed";
  EventOrActionCodes[EventOrActionCodes["Display"] = 77] = "Display";
  EventOrActionCodes[EventOrActionCodes["Displayed"] = 78] = "Displayed";
  EventOrActionCodes[EventOrActionCodes["DisplayFailed"] = 87] = "DisplayFailed";
  EventOrActionCodes[EventOrActionCodes["Distorted"] = 91] = "Distorted";
  EventOrActionCodes[EventOrActionCodes["Downloaded"] = 25] = "Downloaded";
  EventOrActionCodes[EventOrActionCodes["Enable"] = 26] = "Enable";
  EventOrActionCodes[EventOrActionCodes["Enabled"] = 76] = "Enabled";
  EventOrActionCodes[EventOrActionCodes["EnableFailed"] = 221] = "EnableFailed";
  EventOrActionCodes[EventOrActionCodes["Error"] = 79] = "Error";
  EventOrActionCodes[EventOrActionCodes["ErrorCleared"] = 279] = "ErrorCleared";
  EventOrActionCodes[EventOrActionCodes["Established"] = 29] = "Established";
  EventOrActionCodes[EventOrActionCodes["EventStarted"] = 287] = "EventStarted";
  EventOrActionCodes[EventOrActionCodes["EventStopped"] = 288] = "EventStopped";
  EventOrActionCodes[EventOrActionCodes["Exceeded"] = 139] = "Exceeded";
  EventOrActionCodes[EventOrActionCodes["Execute"] = 30] = "Execute";
  EventOrActionCodes[EventOrActionCodes["Expired"] = 64] = "Expired";
  EventOrActionCodes[EventOrActionCodes["Failed"] = 85] = "Failed";
  EventOrActionCodes[EventOrActionCodes["Frozen"] = 88] = "Frozen";
  EventOrActionCodes[EventOrActionCodes["Full"] = 32] = "Full";
  EventOrActionCodes[EventOrActionCodes["HighDistortion"] = 69] = "HighDistortion";
  EventOrActionCodes[EventOrActionCodes["HighDistortionCleared"] = 71] = "HighDistortionCleared";
  EventOrActionCodes[EventOrActionCodes["ImbalanceCleared"] = 75] = "ImbalanceCleared";
  EventOrActionCodes[EventOrActionCodes["Imbalanced"] = 98] = "Imbalanced";
  EventOrActionCodes[EventOrActionCodes["Inactive"] = 100] = "Inactive";
  EventOrActionCodes[EventOrActionCodes["InactiveCleared"] = 72] = "InactiveCleared";
  EventOrActionCodes[EventOrActionCodes["Increased"] = 102] = "Increased";
  EventOrActionCodes[EventOrActionCodes["Initialized"] = 33] = "Initialized";
  EventOrActionCodes[EventOrActionCodes["InProgress"] = 34] = "InProgress";
  EventOrActionCodes[EventOrActionCodes["Installed"] = 105] = "Installed";
  EventOrActionCodes[EventOrActionCodes["Invalid"] = 35] = "Invalid";
  EventOrActionCodes[EventOrActionCodes["LimitChanged"] = 296] = "LimitChanged";
  EventOrActionCodes[EventOrActionCodes["LimitReached"] = 286] = "LimitReached";
  EventOrActionCodes[EventOrActionCodes["Loaded"] = 36] = "Loaded";
  EventOrActionCodes[EventOrActionCodes["LossDetected"] = 47] = "LossDetected";
  EventOrActionCodes[EventOrActionCodes["MaxLimitChanged"] = 295] = "MaxLimitChanged";
  EventOrActionCodes[EventOrActionCodes["MaxLimitCleared"] = 293] = "MaxLimitCleared";
  EventOrActionCodes[EventOrActionCodes["MaxLimitReached"] = 93] = "MaxLimitReached";
  EventOrActionCodes[EventOrActionCodes["MaxLimitReachedCleared"] = 73] = "MaxLimitReachedCleared";
  EventOrActionCodes[EventOrActionCodes["MinLimitChanged"] = 294] = "MinLimitChanged";
  EventOrActionCodes[EventOrActionCodes["MinLimitCleared"] = 292] = "MinLimitCleared";
  EventOrActionCodes[EventOrActionCodes["MinLimitReached"] = 150] = "MinLimitReached";
  EventOrActionCodes[EventOrActionCodes["Mismatched"] = 159] = "Mismatched";
  EventOrActionCodes[EventOrActionCodes["Missing"] = 285] = "Missing";
  EventOrActionCodes[EventOrActionCodes["Normal"] = 37] = "Normal";
  EventOrActionCodes[EventOrActionCodes["NotArmed"] = 290] = "NotArmed";
  EventOrActionCodes[EventOrActionCodes["NotAuthorized"] = 38] = "NotAuthorized";
  EventOrActionCodes[EventOrActionCodes["NotFound"] = 160] = "NotFound";
  EventOrActionCodes[EventOrActionCodes["Open"] = 298] = "Open";
  EventOrActionCodes[EventOrActionCodes["Opened"] = 39] = "Opened";
  EventOrActionCodes[EventOrActionCodes["OptedIn"] = 80] = "OptedIn";
  EventOrActionCodes[EventOrActionCodes["OptedOut"] = 81] = "OptedOut";
  EventOrActionCodes[EventOrActionCodes["OutofRange"] = 40] = "OutofRange";
  EventOrActionCodes[EventOrActionCodes["OutofRangeCleared"] = 74] = "OutofRangeCleared";
  EventOrActionCodes[EventOrActionCodes["Overflow"] = 177] = "Overflow";
  EventOrActionCodes[EventOrActionCodes["Preempted"] = 41] = "Preempted";
  EventOrActionCodes[EventOrActionCodes["Processed"] = 44] = "Processed";
  EventOrActionCodes[EventOrActionCodes["Read"] = 46] = "Read";
  EventOrActionCodes[EventOrActionCodes["Ready"] = 48] = "Ready";
  EventOrActionCodes[EventOrActionCodes["ReadyForActivation"] = 280] = "ReadyForActivation";
  EventOrActionCodes[EventOrActionCodes["ReEstablished"] = 49] = "ReEstablished";
  EventOrActionCodes[EventOrActionCodes["Registered"] = 50] = "Registered";
  EventOrActionCodes[EventOrActionCodes["Released"] = 51] = "Released";
  EventOrActionCodes[EventOrActionCodes["Removed"] = 212] = "Removed";
  EventOrActionCodes[EventOrActionCodes["Replaced"] = 52] = "Replaced";
  EventOrActionCodes[EventOrActionCodes["Reprogrammed"] = 213] = "Reprogrammed";
  EventOrActionCodes[EventOrActionCodes["Reset"] = 214] = "Reset";
  EventOrActionCodes[EventOrActionCodes["ResetFailed"] = 65] = "ResetFailed";
  EventOrActionCodes[EventOrActionCodes["ResetOccurred"] = 215] = "ResetOccurred";
  EventOrActionCodes[EventOrActionCodes["Restarted"] = 53] = "Restarted";
  EventOrActionCodes[EventOrActionCodes["Restored"] = 216] = "Restored";
  EventOrActionCodes[EventOrActionCodes["Reversed"] = 219] = "Reversed";
  EventOrActionCodes[EventOrActionCodes["SagStarted"] = 223] = "SagStarted";
  EventOrActionCodes[EventOrActionCodes["SagStopped"] = 224] = "SagStopped";
  EventOrActionCodes[EventOrActionCodes["Schedule"] = 300] = "Schedule";
  EventOrActionCodes[EventOrActionCodes["Scheduled"] = 225] = "Scheduled";
  EventOrActionCodes[EventOrActionCodes["ScheduleFailed"] = 301] = "ScheduleFailed";
  EventOrActionCodes[EventOrActionCodes["Sealed"] = 227] = "Sealed";
  EventOrActionCodes[EventOrActionCodes["Start"] = 54] = "Start";
  EventOrActionCodes[EventOrActionCodes["Started"] = 242] = "Started";
  EventOrActionCodes[EventOrActionCodes["StartFailed"] = 217] = "StartFailed";
  EventOrActionCodes[EventOrActionCodes["Stop"] = 55] = "Stop";
  EventOrActionCodes[EventOrActionCodes["StopFailed"] = 218] = "StopFailed";
  EventOrActionCodes[EventOrActionCodes["Stopped"] = 243] = "Stopped";
  EventOrActionCodes[EventOrActionCodes["Substituted"] = 56] = "Substituted";
  EventOrActionCodes[EventOrActionCodes["Succeeded"] = 58] = "Succeeded";
  EventOrActionCodes[EventOrActionCodes["SwellStarted"] = 248] = "SwellStarted";
  EventOrActionCodes[EventOrActionCodes["SwellStopped"] = 249] = "SwellStopped";
  EventOrActionCodes[EventOrActionCodes["SwitchPositionChanged"] = 289] = "SwitchPositionChanged";
  EventOrActionCodes[EventOrActionCodes["TamperCleared"] = 291] = "TamperCleared";
  EventOrActionCodes[EventOrActionCodes["TamperDetected"] = 257] = "TamperDetected";
  EventOrActionCodes[EventOrActionCodes["Terminate"] = 302] = "Terminate";
  EventOrActionCodes[EventOrActionCodes["Terminated"] = 59] = "Terminated";
  EventOrActionCodes[EventOrActionCodes["TerminateFailed"] = 303] = "TerminateFailed";
  EventOrActionCodes[EventOrActionCodes["Tilted"] = 263] = "Tilted";
  EventOrActionCodes[EventOrActionCodes["Uninitialized"] = 61] = "Uninitialized";
  EventOrActionCodes[EventOrActionCodes["Unlocked"] = 62] = "Unlocked";
  EventOrActionCodes[EventOrActionCodes["Unsealed"] = 269] = "Unsealed";
  EventOrActionCodes[EventOrActionCodes["Unsecure"] = 63] = "Unsecure";
  EventOrActionCodes[EventOrActionCodes["Unstable"] = 270] = "Unstable";
  EventOrActionCodes[EventOrActionCodes["Uploaded"] = 60] = "Uploaded";
  EventOrActionCodes[EventOrActionCodes["WarmStarted"] = 278] = "WarmStarted";
  EventOrActionCodes[EventOrActionCodes["WriteFailed"] = 282] = "WriteFailed";
})(EventOrActionCodes || (EventOrActionCodes = {}));

var EndDeviceEventOrActionCodes = EventOrActionCodes;

var createObject = function createObject(ref, fields) {
  try {
    var codes = ref.split('.').map(function (value) {
      var code = Number.parseInt(value);

      if (Number.isNaN(code)) {
        throw new Error('Invalid number');
      }

      return code;
    });

    if (codes.length !== fields.length) {
      throw new Error('Invalid code length');
    }

    return fields.reduce(function (acc, field, idx) {
      acc[field] = codes[idx];
      return acc;
    }, {});
  } catch (e) {
    throw Error("Invalid ref: " + e.message);
  }
};

var Codes$2 = {
  EndDeviceEventTypeCodes: EndDeviceEventTypeCodes,
  EndDeviceDomainCodes: EndDeviceDomainCodes,
  EndDeviceSubDomainCodes: EndDeviceSubDomainCodes,
  EndDeviceEventOrActionCodes: EndDeviceEventOrActionCodes
};

var EndDeviceEventType = function EndDeviceEventType(_ref) {
  var ref = _ref.ref,
      object = _ref.object;
  this.eventType = void 0;
  this.eventTypeValue = void 0;
  this.domain = void 0;
  this.domainValue = void 0;
  this.subDomainValue = void 0;
  this.subDomain = void 0;
  this.eventOrActionValue = void 0;
  this.eventOrAction = void 0;
  var obj = ref ? createObject(ref, ['eventType', 'domain', 'subDomain', 'eventOrAction']) : object;
  this.eventTypeValue = obj.eventType;
  this.eventType = EndDeviceEventTypeCodes[obj.eventType];
  this.domainValue = obj.domain;
  this.domain = EndDeviceDomainCodes[obj.domain];
  this.subDomainValue = obj.subDomain;
  this.subDomain = EndDeviceSubDomainCodes[obj.subDomain];
  this.eventOrActionValue = obj.eventOrAction;
  this.eventOrAction = EndDeviceEventOrActionCodes[obj.eventOrAction];
};

var CategoryCodes;

(function (CategoryCodes) {
  CategoryCodes[CategoryCodes["Validity"] = 0] = "Validity";
  CategoryCodes[CategoryCodes["Diagnostics"] = 1] = "Diagnostics";
  CategoryCodes[CategoryCodes["PowerQuality"] = 2] = "PowerQuality";
  CategoryCodes[CategoryCodes["Tampering"] = 3] = "Tampering";
  CategoryCodes[CategoryCodes["DataCollection"] = 4] = "DataCollection";
  CategoryCodes[CategoryCodes["Reasonability"] = 5] = "Reasonability";
  CategoryCodes[CategoryCodes["Validation"] = 6] = "Validation";
  CategoryCodes[CategoryCodes["Edited"] = 7] = "Edited";
  CategoryCodes[CategoryCodes["Estimated"] = 8] = "Estimated";
  CategoryCodes[CategoryCodes["Questionable"] = 10] = "Questionable";
  CategoryCodes[CategoryCodes["Derived"] = 11] = "Derived";
  CategoryCodes[CategoryCodes["Projected"] = 12] = "Projected";
})(CategoryCodes || (CategoryCodes = {}));

var CategoryCodes$1 = CategoryCodes;

var _CategoryIndexCodes;
var Validity;

(function (Validity) {
  Validity[Validity["DataValid"] = 0] = "DataValid";
  Validity[Validity["Validated"] = 1] = "Validated";
})(Validity || (Validity = {}));

var Diagnostics;

(function (Diagnostics) {
  Diagnostics[Diagnostics["WatchdogFlag"] = 4] = "WatchdogFlag";
  Diagnostics[Diagnostics["DiagnosticsFlag"] = 0] = "DiagnosticsFlag";
  Diagnostics[Diagnostics["BatteryLow"] = 1] = "BatteryLow";
  Diagnostics[Diagnostics["SensorFailure"] = 3] = "SensorFailure";
  Diagnostics[Diagnostics["ParityError"] = 5] = "ParityError";
  Diagnostics[Diagnostics["CRCError"] = 6] = "CRCError";
  Diagnostics[Diagnostics["RAMChecksumError"] = 7] = "RAMChecksumError";
  Diagnostics[Diagnostics["ROMChecksumError"] = 8] = "ROMChecksumError";
  Diagnostics[Diagnostics["ClockError"] = 9] = "ClockError";
})(Diagnostics || (Diagnostics = {}));

var PowerQuality;

(function (PowerQuality) {
  PowerQuality[PowerQuality["PowerFail"] = 32] = "PowerFail";
  PowerQuality[PowerQuality["PowerQualityFlag"] = 0] = "PowerQualityFlag";
  PowerQuality[PowerQuality["ExcessiveOutageCount"] = 1] = "ExcessiveOutageCount";
  PowerQuality[PowerQuality["PqCounter"] = 2] = "PqCounter";
  PowerQuality[PowerQuality["ServiceDisconnectSwitching"] = 3] = "ServiceDisconnectSwitching";
})(PowerQuality || (PowerQuality = {}));

var Tampering;

(function (Tampering) {
  Tampering[Tampering["RevenueProtectionSuspect"] = 3] = "RevenueProtectionSuspect";
  Tampering[Tampering["ReverseRotation"] = 4] = "ReverseRotation";
  Tampering[Tampering["StaticDataFlag"] = 5] = "StaticDataFlag";
  Tampering[Tampering["RevenueProtection"] = 0] = "RevenueProtection";
  Tampering[Tampering["CoverOpened"] = 1] = "CoverOpened";
  Tampering[Tampering["LogicalDisconnect"] = 2] = "LogicalDisconnect";
})(Tampering || (Tampering = {}));

var DataCollection;

(function (DataCollection) {
  DataCollection[DataCollection["OverflowConditionDetected"] = 1] = "OverflowConditionDetected";
  DataCollection[DataCollection["PartialInterval"] = 2] = "PartialInterval";
  DataCollection[DataCollection["LongInterval"] = 3] = "LongInterval";
  DataCollection[DataCollection["SkippedInterval"] = 4] = "SkippedInterval";
  DataCollection[DataCollection["TestData"] = 5] = "TestData";
  DataCollection[DataCollection["DstInEffect"] = 16] = "DstInEffect";
  DataCollection[DataCollection["DstChangeOccurred"] = 259] = "DstChangeOccurred";
  DataCollection[DataCollection["AlarmFlag"] = 0] = "AlarmFlag";
  DataCollection[DataCollection["ConfigurationChanged"] = 6] = "ConfigurationChanged";
  DataCollection[DataCollection["NotRecording"] = 7] = "NotRecording";
  DataCollection[DataCollection["ResetOccurred"] = 8] = "ResetOccurred";
  DataCollection[DataCollection["ClockChanged"] = 9] = "ClockChanged";
  DataCollection[DataCollection["LoadControlOccurred"] = 10] = "LoadControlOccurred";
  DataCollection[DataCollection["ClockSetForward"] = 64] = "ClockSetForward";
  DataCollection[DataCollection["ClockSetBackward"] = 128] = "ClockSetBackward";
  DataCollection[DataCollection["FailedProbeAttempt"] = 129] = "FailedProbeAttempt";
  DataCollection[DataCollection["CustomerRead"] = 130] = "CustomerRead";
  DataCollection[DataCollection["ManualRead"] = 131] = "ManualRead";
})(DataCollection || (DataCollection = {}));

var FailedReasonability;

(function (FailedReasonability) {
  FailedReasonability[FailedReasonability["DataOutsideExpectedRange"] = 256] = "DataOutsideExpectedRange";
  FailedReasonability[FailedReasonability["ErrorCode"] = 257] = "ErrorCode";
  FailedReasonability[FailedReasonability["KnownMissingRead"] = 259] = "KnownMissingRead";
  FailedReasonability[FailedReasonability["Suspect"] = 258] = "Suspect";
})(FailedReasonability || (FailedReasonability = {}));

var FailedValidation;

(function (FailedValidation) {
  FailedValidation[FailedValidation["FailedValidation"] = 0] = "FailedValidation";
  FailedValidation[FailedValidation["ZeroUsageOnActiveMeter"] = 1] = "ZeroUsageOnActiveMeter";
  FailedValidation[FailedValidation["UsageOnInactiveMeter"] = 2] = "UsageOnInactiveMeter";
  FailedValidation[FailedValidation["UsageAboveMaximum"] = 3] = "UsageAboveMaximum";
  FailedValidation[FailedValidation["UsageBelowMinimum"] = 4] = "UsageBelowMinimum";
  FailedValidation[FailedValidation["UsageAboveMaximumPct"] = 5] = "UsageAboveMaximumPct";
  FailedValidation[FailedValidation["UsageBelowMinimumPct"] = 6] = "UsageBelowMinimumPct";
  FailedValidation[FailedValidation["TOUSumCheckFailure"] = 9] = "TOUSumCheckFailure";
})(FailedValidation || (FailedValidation = {}));

var Edited;

(function (Edited) {
  Edited[Edited["ManuallyEdited"] = 0] = "ManuallyEdited";
  Edited[Edited["ManuallyAdded"] = 1] = "ManuallyAdded";
  Edited[Edited["ManuallyRejected"] = 3] = "ManuallyRejected";
})(Edited || (Edited = {}));

var Estimated;

(function (Estimated) {
  Estimated[Estimated["Estimated"] = 0] = "Estimated";
  Estimated[Estimated["LinearInterpolation"] = 1001] = "LinearInterpolation";
  Estimated[Estimated["ProfiledInterpolation"] = 1002] = "ProfiledInterpolation";
})(Estimated || (Estimated = {}));

var Questionable;

(function (Questionable) {
  Questionable[Questionable["Indeterminate"] = 0] = "Indeterminate";
  Questionable[Questionable["ManuallyAccepted"] = 1] = "ManuallyAccepted";
})(Questionable || (Questionable = {}));

var Derived;

(function (Derived) {
  Derived[Derived["DerivedDeterministic"] = 0] = "DerivedDeterministic";
  Derived[Derived["DerivedInferred"] = 1] = "DerivedInferred";
})(Derived || (Derived = {}));

var Projected;

(function (Projected) {
  Projected[Projected["Projected"] = 0] = "Projected";
  Projected[Projected["LinearProjection"] = 1001] = "LinearProjection";
  Projected[Projected["ProfiledProjection"] = 1002] = "ProfiledProjection";
})(Projected || (Projected = {}));

var CategoryIndexCodes = (_CategoryIndexCodes = {}, _CategoryIndexCodes[CategoryCodes$1.Validity] = Validity, _CategoryIndexCodes[CategoryCodes$1.Diagnostics] = Diagnostics, _CategoryIndexCodes[CategoryCodes$1.PowerQuality] = PowerQuality, _CategoryIndexCodes[CategoryCodes$1.Tampering] = Tampering, _CategoryIndexCodes[CategoryCodes$1.DataCollection] = DataCollection, _CategoryIndexCodes[CategoryCodes$1.Reasonability] = FailedReasonability, _CategoryIndexCodes[CategoryCodes$1.Validation] = FailedValidation, _CategoryIndexCodes[CategoryCodes$1.Edited] = Edited, _CategoryIndexCodes[CategoryCodes$1.Estimated] = Estimated, _CategoryIndexCodes[CategoryCodes$1.Questionable] = Questionable, _CategoryIndexCodes[CategoryCodes$1.Derived] = Derived, _CategoryIndexCodes[CategoryCodes$1.Projected] = Projected, _CategoryIndexCodes);

var SystemIdentifierCodes;

(function (SystemIdentifierCodes) {
  SystemIdentifierCodes[SystemIdentifierCodes["None"] = 0] = "None";
  SystemIdentifierCodes[SystemIdentifierCodes["EndDevice"] = 1] = "EndDevice";
  SystemIdentifierCodes[SystemIdentifierCodes["MeteringSystem"] = 2] = "MeteringSystem";
  SystemIdentifierCodes[SystemIdentifierCodes["MDM"] = 3] = "MDM";
  SystemIdentifierCodes[SystemIdentifierCodes["Other"] = 4] = "Other";
  SystemIdentifierCodes[SystemIdentifierCodes["External"] = 5] = "External";
})(SystemIdentifierCodes || (SystemIdentifierCodes = {}));

var SystemIdentifierCodes$1 = SystemIdentifierCodes;

var Codes$1 = {
  CategoryCodes: CategoryCodes$1,
  CategoryIndexCodes: CategoryIndexCodes,
  SystemIdentifierCodes: SystemIdentifierCodes$1
};

var ReadingQuality = function ReadingQuality(_ref) {
  var ref = _ref.ref,
      object = _ref.object;
  this.category = void 0;
  this.categoryValue = void 0;
  this.categoryIndex = void 0;
  this.categoryIndexValue = void 0;
  this.systemIdentifierValue = void 0;
  this.systemIdentifier = void 0;
  var obj = ref ? createObject(ref, ['systemIdentifier', 'category', 'categoryIndex']) : object;
  this.categoryValue = obj.category;
  this.category = CategoryCodes$1[obj.category];
  this.categoryIndexValue = obj.categoryIndex;
  this.categoryIndex = CategoryIndexCodes[obj.category] ? CategoryIndexCodes[obj.category][obj.categoryIndex] : undefined;
  this.systemIdentifierValue = obj.systemIdentifier;
  this.systemIdentifier = SystemIdentifierCodes$1[obj.systemIdentifier];
};

var MacroPeriodCodes;

(function (MacroPeriodCodes) {
  MacroPeriodCodes[MacroPeriodCodes["None"] = 0] = "None";
  MacroPeriodCodes[MacroPeriodCodes["BillingPeriod"] = 8] = "BillingPeriod";
  MacroPeriodCodes[MacroPeriodCodes["Daily"] = 11] = "Daily";
  MacroPeriodCodes[MacroPeriodCodes["Monthly"] = 13] = "Monthly";
  MacroPeriodCodes[MacroPeriodCodes["Seasonal"] = 22] = "Seasonal";
  MacroPeriodCodes[MacroPeriodCodes["Weekly"] = 24] = "Weekly";
  MacroPeriodCodes[MacroPeriodCodes["SpecifiedPeriod"] = 32] = "SpecifiedPeriod";
})(MacroPeriodCodes || (MacroPeriodCodes = {}));

var MacroPeriodCodes$1 = MacroPeriodCodes;

var AggregateCodes;

(function (AggregateCodes) {
  AggregateCodes[AggregateCodes["None"] = 0] = "None";
  AggregateCodes[AggregateCodes["Average"] = 2] = "Average";
  AggregateCodes[AggregateCodes["Excess"] = 4] = "Excess";
  AggregateCodes[AggregateCodes["HighThreshold"] = 5] = "HighThreshold";
  AggregateCodes[AggregateCodes["LowThreshold"] = 7] = "LowThreshold";
  AggregateCodes[AggregateCodes["Maximum"] = 8] = "Maximum";
  AggregateCodes[AggregateCodes["Minimum"] = 9] = "Minimum";
  AggregateCodes[AggregateCodes["Nominal"] = 11] = "Nominal";
  AggregateCodes[AggregateCodes["Normal"] = 12] = "Normal";
  AggregateCodes[AggregateCodes["SecondMaximum"] = 16] = "SecondMaximum";
  AggregateCodes[AggregateCodes["SecondMinimum"] = 17] = "SecondMinimum";
  AggregateCodes[AggregateCodes["ThirdMaximum"] = 23] = "ThirdMaximum";
  AggregateCodes[AggregateCodes["FourthMaximum"] = 24] = "FourthMaximum";
  AggregateCodes[AggregateCodes["FifthMaximum"] = 25] = "FifthMaximum";
  AggregateCodes[AggregateCodes["Sum"] = 26] = "Sum";
  AggregateCodes[AggregateCodes["High"] = 27] = "High";
  AggregateCodes[AggregateCodes["Low"] = 28] = "Low";
})(AggregateCodes || (AggregateCodes = {}));

var AggregateCodes$1 = AggregateCodes;

var MeasuringPeriodCodes;

(function (MeasuringPeriodCodes) {
  MeasuringPeriodCodes[MeasuringPeriodCodes["None"] = 0] = "None";
  MeasuringPeriodCodes[MeasuringPeriodCodes["TenMinute"] = 1] = "TenMinute";
  MeasuringPeriodCodes[MeasuringPeriodCodes["FifteenMinute"] = 2] = "FifteenMinute";
  MeasuringPeriodCodes[MeasuringPeriodCodes["OneMinute"] = 3] = "OneMinute";
  MeasuringPeriodCodes[MeasuringPeriodCodes["TwentyfourHour"] = 4] = "TwentyfourHour";
  MeasuringPeriodCodes[MeasuringPeriodCodes["ThirtyMinute"] = 5] = "ThirtyMinute";
  MeasuringPeriodCodes[MeasuringPeriodCodes["FiveMinute"] = 6] = "FiveMinute";
  MeasuringPeriodCodes[MeasuringPeriodCodes["SixtyMinute"] = 7] = "SixtyMinute";
  MeasuringPeriodCodes[MeasuringPeriodCodes["TwoMinute"] = 10] = "TwoMinute";
  MeasuringPeriodCodes[MeasuringPeriodCodes["ThreeMinute"] = 14] = "ThreeMinute";
  MeasuringPeriodCodes[MeasuringPeriodCodes["Present"] = 15] = "Present";
  MeasuringPeriodCodes[MeasuringPeriodCodes["Previous"] = 16] = "Previous";
  MeasuringPeriodCodes[MeasuringPeriodCodes["TwentyMinute"] = 31] = "TwentyMinute";
  MeasuringPeriodCodes[MeasuringPeriodCodes["FixedBlock60Min"] = 50] = "FixedBlock60Min";
  MeasuringPeriodCodes[MeasuringPeriodCodes["FixedBlock30Min"] = 51] = "FixedBlock30Min";
  MeasuringPeriodCodes[MeasuringPeriodCodes["FixedBlock20Min"] = 52] = "FixedBlock20Min";
  MeasuringPeriodCodes[MeasuringPeriodCodes["FixedBlock15Min"] = 53] = "FixedBlock15Min";
  MeasuringPeriodCodes[MeasuringPeriodCodes["FixedBlock10Min"] = 54] = "FixedBlock10Min";
  MeasuringPeriodCodes[MeasuringPeriodCodes["FixedBlock5Min"] = 55] = "FixedBlock5Min";
  MeasuringPeriodCodes[MeasuringPeriodCodes["FixedBlock1Min"] = 56] = "FixedBlock1Min";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock60MinIntvl30MinSubIntvl"] = 57] = "RollingBlock60MinIntvl30MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock60MinIntvl20MinSubIntvl"] = 58] = "RollingBlock60MinIntvl20MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock60MinIntvl15MinSubIntvl"] = 59] = "RollingBlock60MinIntvl15MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock60MinIntvl12MinSubIntvl"] = 60] = "RollingBlock60MinIntvl12MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock60MinIntvl10MinSubIntvl"] = 61] = "RollingBlock60MinIntvl10MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock60MinIntvl6MinSubIntvl"] = 62] = "RollingBlock60MinIntvl6MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock60MinIntvl5MinSubIntvl"] = 63] = "RollingBlock60MinIntvl5MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock60MinIntvl4MinSubIntvl"] = 64] = "RollingBlock60MinIntvl4MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock30MinIntvl15MinSubIntvl"] = 65] = "RollingBlock30MinIntvl15MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock30MinIntvl10MinSubIntvl"] = 66] = "RollingBlock30MinIntvl10MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock30MinIntvl6MinSubIntvl"] = 67] = "RollingBlock30MinIntvl6MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock30MinIntvl5MinSubIntvl"] = 68] = "RollingBlock30MinIntvl5MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock30MinIntvl3MinSubIntvl"] = 69] = "RollingBlock30MinIntvl3MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock30MinIntvl2MinSubIntvl"] = 70] = "RollingBlock30MinIntvl2MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock15MinIntvl5MinSubIntvl"] = 71] = "RollingBlock15MinIntvl5MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock15MinIntvl3MinSubIntvl"] = 72] = "RollingBlock15MinIntvl3MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock15MinIntvl1MinSubIntvl"] = 73] = "RollingBlock15MinIntvl1MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock10MinIntvl5MinSubIntvl"] = 74] = "RollingBlock10MinIntvl5MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock10MinIntvl2MinSubIntvl"] = 75] = "RollingBlock10MinIntvl2MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock10MinIntvl1MinSubIntvl"] = 76] = "RollingBlock10MinIntvl1MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["RollingBlock5MinIntvl1MinSubIntvl"] = 77] = "RollingBlock5MinIntvl1MinSubIntvl";
  MeasuringPeriodCodes[MeasuringPeriodCodes["TwelveMinute"] = 78] = "TwelveMinute";
  MeasuringPeriodCodes[MeasuringPeriodCodes["TwoHour"] = 79] = "TwoHour";
  MeasuringPeriodCodes[MeasuringPeriodCodes["FourHour"] = 80] = "FourHour";
  MeasuringPeriodCodes[MeasuringPeriodCodes["SixHour"] = 81] = "SixHour";
  MeasuringPeriodCodes[MeasuringPeriodCodes["TwelveHour"] = 82] = "TwelveHour";
  MeasuringPeriodCodes[MeasuringPeriodCodes["ThreeHour"] = 83] = "ThreeHour";
  MeasuringPeriodCodes[MeasuringPeriodCodes["SpecifiedInterval"] = 100] = "SpecifiedInterval";
  MeasuringPeriodCodes[MeasuringPeriodCodes["SpecifiedFixedBlock"] = 101] = "SpecifiedFixedBlock";
  MeasuringPeriodCodes[MeasuringPeriodCodes["SpecifiedRollingBlock"] = 102] = "SpecifiedRollingBlock";
})(MeasuringPeriodCodes || (MeasuringPeriodCodes = {}));

var MeasuringPeriodCodes$1 = MeasuringPeriodCodes;

var AccumulationCodes;

(function (AccumulationCodes) {
  AccumulationCodes[AccumulationCodes["None"] = 0] = "None";
  AccumulationCodes[AccumulationCodes["BulkQuantity"] = 1] = "BulkQuantity";
  AccumulationCodes[AccumulationCodes["ContinuousCumulative"] = 2] = "ContinuousCumulative";
  AccumulationCodes[AccumulationCodes["Cumulative"] = 3] = "Cumulative";
  AccumulationCodes[AccumulationCodes["DeltaData"] = 4] = "DeltaData";
  AccumulationCodes[AccumulationCodes["Indicating"] = 6] = "Indicating";
  AccumulationCodes[AccumulationCodes["Summation"] = 9] = "Summation";
  AccumulationCodes[AccumulationCodes["TimeDelay"] = 10] = "TimeDelay";
  AccumulationCodes[AccumulationCodes["Instantaneous"] = 12] = "Instantaneous";
  AccumulationCodes[AccumulationCodes["LatchingQuantity"] = 13] = "LatchingQuantity";
  AccumulationCodes[AccumulationCodes["BoundedQuantity"] = 14] = "BoundedQuantity";
})(AccumulationCodes || (AccumulationCodes = {}));

var AccumulationCodes$1 = AccumulationCodes;

var FlowDirectionCodes;

(function (FlowDirectionCodes) {
  FlowDirectionCodes[FlowDirectionCodes["None"] = 0] = "None";
  FlowDirectionCodes[FlowDirectionCodes["Forward"] = 1] = "Forward";
  FlowDirectionCodes[FlowDirectionCodes["Lagging"] = 2] = "Lagging";
  FlowDirectionCodes[FlowDirectionCodes["Leading"] = 3] = "Leading";
  FlowDirectionCodes[FlowDirectionCodes["Net"] = 4] = "Net";
  FlowDirectionCodes[FlowDirectionCodes["Q1plusQ2"] = 5] = "Q1plusQ2";
  FlowDirectionCodes[FlowDirectionCodes["Q1plusQ3"] = 7] = "Q1plusQ3";
  FlowDirectionCodes[FlowDirectionCodes["Q1plusQ4"] = 8] = "Q1plusQ4";
  FlowDirectionCodes[FlowDirectionCodes["Q1minusQ4"] = 9] = "Q1minusQ4";
  FlowDirectionCodes[FlowDirectionCodes["Q2plusQ3"] = 10] = "Q2plusQ3";
  FlowDirectionCodes[FlowDirectionCodes["Q2plusQ4"] = 11] = "Q2plusQ4";
  FlowDirectionCodes[FlowDirectionCodes["Q2minusQ3"] = 12] = "Q2minusQ3";
  FlowDirectionCodes[FlowDirectionCodes["Q3plusQ4"] = 13] = "Q3plusQ4";
  FlowDirectionCodes[FlowDirectionCodes["Q3minusQ2"] = 14] = "Q3minusQ2";
  FlowDirectionCodes[FlowDirectionCodes["Quadrant1"] = 15] = "Quadrant1";
  FlowDirectionCodes[FlowDirectionCodes["Quadrant2"] = 16] = "Quadrant2";
  FlowDirectionCodes[FlowDirectionCodes["Quadrant3"] = 17] = "Quadrant3";
  FlowDirectionCodes[FlowDirectionCodes["Quadrant4"] = 18] = "Quadrant4";
  FlowDirectionCodes[FlowDirectionCodes["Reverse"] = 19] = "Reverse";
  FlowDirectionCodes[FlowDirectionCodes["Total"] = 20] = "Total";
  FlowDirectionCodes[FlowDirectionCodes["TotalByPhase"] = 21] = "TotalByPhase";
})(FlowDirectionCodes || (FlowDirectionCodes = {}));

var FlowDirectionCodes$1 = FlowDirectionCodes;

var CommodityCodes;

(function (CommodityCodes) {
  CommodityCodes[CommodityCodes["None"] = 0] = "None";
  CommodityCodes[CommodityCodes["ElectricitySecondaryMetered"] = 1] = "ElectricitySecondaryMetered";
  CommodityCodes[CommodityCodes["ElectricityPrimaryMetered"] = 2] = "ElectricityPrimaryMetered";
  CommodityCodes[CommodityCodes["Communication"] = 3] = "Communication";
  CommodityCodes[CommodityCodes["Air"] = 4] = "Air";
  CommodityCodes[CommodityCodes["InsulativeGas"] = 5] = "InsulativeGas";
  CommodityCodes[CommodityCodes["InsulativeOil"] = 6] = "InsulativeOil";
  CommodityCodes[CommodityCodes["NaturalGas"] = 7] = "NaturalGas";
  CommodityCodes[CommodityCodes["Propane"] = 8] = "Propane";
  CommodityCodes[CommodityCodes["PotableWater"] = 9] = "PotableWater";
  CommodityCodes[CommodityCodes["Steam"] = 10] = "Steam";
  CommodityCodes[CommodityCodes["WasteWater"] = 11] = "WasteWater";
  CommodityCodes[CommodityCodes["HeatingFluid"] = 12] = "HeatingFluid";
  CommodityCodes[CommodityCodes["CoolingFluid"] = 13] = "CoolingFluid";
  CommodityCodes[CommodityCodes["NonpotableWater"] = 14] = "NonpotableWater";
  CommodityCodes[CommodityCodes["Nox"] = 15] = "Nox";
  CommodityCodes[CommodityCodes["So2"] = 16] = "So2";
  CommodityCodes[CommodityCodes["Ch4"] = 17] = "Ch4";
  CommodityCodes[CommodityCodes["Co2"] = 18] = "Co2";
  CommodityCodes[CommodityCodes["Carbon"] = 19] = "Carbon";
  CommodityCodes[CommodityCodes["Hch"] = 20] = "Hch";
  CommodityCodes[CommodityCodes["Pfc"] = 21] = "Pfc";
  CommodityCodes[CommodityCodes["Sf6"] = 22] = "Sf6";
  CommodityCodes[CommodityCodes["TvLicence"] = 23] = "TvLicence";
  CommodityCodes[CommodityCodes["Internet"] = 24] = "Internet";
  CommodityCodes[CommodityCodes["Refuse"] = 25] = "Refuse";
  CommodityCodes[CommodityCodes["H2"] = 26] = "H2";
  CommodityCodes[CommodityCodes["C2h2"] = 27] = "C2h2";
  CommodityCodes[CommodityCodes["C2h4"] = 28] = "C2h4";
  CommodityCodes[CommodityCodes["C2h6"] = 29] = "C2h6";
  CommodityCodes[CommodityCodes["Co"] = 30] = "Co";
  CommodityCodes[CommodityCodes["O2"] = 31] = "O2";
  CommodityCodes[CommodityCodes["DissolvedCombustibleGas"] = 32] = "DissolvedCombustibleGas";
  CommodityCodes[CommodityCodes["Co2e"] = 33] = "Co2e";
  CommodityCodes[CommodityCodes["Lead"] = 34] = "Lead";
  CommodityCodes[CommodityCodes["Mercury"] = 35] = "Mercury";
  CommodityCodes[CommodityCodes["Ozone"] = 36] = "Ozone";
  CommodityCodes[CommodityCodes["Pm10"] = 37] = "Pm10";
  CommodityCodes[CommodityCodes["Pm25"] = 38] = "Pm25";
  CommodityCodes[CommodityCodes["Sox"] = 39] = "Sox";
  CommodityCodes[CommodityCodes["Weather"] = 40] = "Weather";
  CommodityCodes[CommodityCodes["Device"] = 41] = "Device";
})(CommodityCodes || (CommodityCodes = {}));

var CommodityCodes$1 = CommodityCodes;

var MeasurementKindCodes;

(function (MeasurementKindCodes) {
  MeasurementKindCodes[MeasurementKindCodes["None"] = 0] = "None";
  MeasurementKindCodes[MeasurementKindCodes["ApparentPowerFactor"] = 2] = "ApparentPowerFactor";
  MeasurementKindCodes[MeasurementKindCodes["Currency"] = 3] = "Currency";
  MeasurementKindCodes[MeasurementKindCodes["Current"] = 4] = "Current";
  MeasurementKindCodes[MeasurementKindCodes["CurrentAngle"] = 5] = "CurrentAngle";
  MeasurementKindCodes[MeasurementKindCodes["CurrentImbalance"] = 6] = "CurrentImbalance";
  MeasurementKindCodes[MeasurementKindCodes["Date"] = 7] = "Date";
  MeasurementKindCodes[MeasurementKindCodes["Demand"] = 8] = "Demand";
  MeasurementKindCodes[MeasurementKindCodes["Distance"] = 9] = "Distance";
  MeasurementKindCodes[MeasurementKindCodes["DistortionVoltAmperes"] = 10] = "DistortionVoltAmperes";
  MeasurementKindCodes[MeasurementKindCodes["Energization"] = 11] = "Energization";
  MeasurementKindCodes[MeasurementKindCodes["Energy"] = 12] = "Energy";
  MeasurementKindCodes[MeasurementKindCodes["EnergizationLoadSide"] = 13] = "EnergizationLoadSide";
  MeasurementKindCodes[MeasurementKindCodes["Fan"] = 14] = "Fan";
  MeasurementKindCodes[MeasurementKindCodes["Frequency"] = 15] = "Frequency";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366ASAI"] = 17] = "Ieee1366ASAI";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366ASIDI"] = 18] = "Ieee1366ASIDI";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366ASIFI"] = 19] = "Ieee1366ASIFI";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366CAIDI"] = 20] = "Ieee1366CAIDI";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366CAIFI"] = 21] = "Ieee1366CAIFI";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366CEMIn"] = 22] = "Ieee1366CEMIn";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366CEMSMIn"] = 23] = "Ieee1366CEMSMIn";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366CTAIDI"] = 24] = "Ieee1366CTAIDI";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366MAIFI"] = 25] = "Ieee1366MAIFI";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366MAIFIe"] = 26] = "Ieee1366MAIFIe";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366SAIDI"] = 27] = "Ieee1366SAIDI";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366SAIFI"] = 28] = "Ieee1366SAIFI";
  MeasurementKindCodes[MeasurementKindCodes["LineLosses"] = 31] = "LineLosses";
  MeasurementKindCodes[MeasurementKindCodes["Losses"] = 32] = "Losses";
  MeasurementKindCodes[MeasurementKindCodes["NegativeSequence"] = 33] = "NegativeSequence";
  MeasurementKindCodes[MeasurementKindCodes["PhasorPowerFactor"] = 34] = "PhasorPowerFactor";
  MeasurementKindCodes[MeasurementKindCodes["PhasorReactivePower"] = 35] = "PhasorReactivePower";
  MeasurementKindCodes[MeasurementKindCodes["PositiveSequence"] = 36] = "PositiveSequence";
  MeasurementKindCodes[MeasurementKindCodes["Power"] = 37] = "Power";
  MeasurementKindCodes[MeasurementKindCodes["PowerFactor"] = 38] = "PowerFactor";
  MeasurementKindCodes[MeasurementKindCodes["QuantityPower"] = 40] = "QuantityPower";
  MeasurementKindCodes[MeasurementKindCodes["Sag"] = 41] = "Sag";
  MeasurementKindCodes[MeasurementKindCodes["Swell"] = 42] = "Swell";
  MeasurementKindCodes[MeasurementKindCodes["SwitchPosition"] = 43] = "SwitchPosition";
  MeasurementKindCodes[MeasurementKindCodes["TapPosition"] = 44] = "TapPosition";
  MeasurementKindCodes[MeasurementKindCodes["TariffRate"] = 45] = "TariffRate";
  MeasurementKindCodes[MeasurementKindCodes["Temperature"] = 46] = "Temperature";
  MeasurementKindCodes[MeasurementKindCodes["TotalHarmonicDistortion"] = 47] = "TotalHarmonicDistortion";
  MeasurementKindCodes[MeasurementKindCodes["TransformerLosses"] = 48] = "TransformerLosses";
  MeasurementKindCodes[MeasurementKindCodes["UnipedeVoltageDip10to15"] = 49] = "UnipedeVoltageDip10to15";
  MeasurementKindCodes[MeasurementKindCodes["UnipedeVoltageDip15to30"] = 50] = "UnipedeVoltageDip15to30";
  MeasurementKindCodes[MeasurementKindCodes["UnipedeVoltageDip30to60"] = 51] = "UnipedeVoltageDip30to60";
  MeasurementKindCodes[MeasurementKindCodes["UnipedeVoltageDip60to90"] = 52] = "UnipedeVoltageDip60to90";
  MeasurementKindCodes[MeasurementKindCodes["UnipedeVoltageDip90to100"] = 53] = "UnipedeVoltageDip90to100";
  MeasurementKindCodes[MeasurementKindCodes["VoltageRMS"] = 54] = "VoltageRMS";
  MeasurementKindCodes[MeasurementKindCodes["VoltageAngle"] = 55] = "VoltageAngle";
  MeasurementKindCodes[MeasurementKindCodes["VoltageExcursion"] = 56] = "VoltageExcursion";
  MeasurementKindCodes[MeasurementKindCodes["VoltageImbalance"] = 57] = "VoltageImbalance";
  MeasurementKindCodes[MeasurementKindCodes["Volume"] = 58] = "Volume";
  MeasurementKindCodes[MeasurementKindCodes["ZeroFlowDuration"] = 59] = "ZeroFlowDuration";
  MeasurementKindCodes[MeasurementKindCodes["ZeroSequence"] = 60] = "ZeroSequence";
  MeasurementKindCodes[MeasurementKindCodes["DistortionPowerFactor"] = 64] = "DistortionPowerFactor";
  MeasurementKindCodes[MeasurementKindCodes["FrequencyExcursion"] = 81] = "FrequencyExcursion";
  MeasurementKindCodes[MeasurementKindCodes["ApplicationContext"] = 90] = "ApplicationContext";
  MeasurementKindCodes[MeasurementKindCodes["ApTitle"] = 91] = "ApTitle";
  MeasurementKindCodes[MeasurementKindCodes["AssetNumber"] = 92] = "AssetNumber";
  MeasurementKindCodes[MeasurementKindCodes["Bandwidth"] = 93] = "Bandwidth";
  MeasurementKindCodes[MeasurementKindCodes["BatteryVoltage"] = 94] = "BatteryVoltage";
  MeasurementKindCodes[MeasurementKindCodes["BroadcastAddress"] = 95] = "BroadcastAddress";
  MeasurementKindCodes[MeasurementKindCodes["DeviceAddressType1"] = 96] = "DeviceAddressType1";
  MeasurementKindCodes[MeasurementKindCodes["DeviceAddressType2"] = 97] = "DeviceAddressType2";
  MeasurementKindCodes[MeasurementKindCodes["DeviceAddressType3"] = 98] = "DeviceAddressType3";
  MeasurementKindCodes[MeasurementKindCodes["DeviceAddressType4"] = 99] = "DeviceAddressType4";
  MeasurementKindCodes[MeasurementKindCodes["DeviceClass"] = 100] = "DeviceClass";
  MeasurementKindCodes[MeasurementKindCodes["ElectronicSerialNumber"] = 101] = "ElectronicSerialNumber";
  MeasurementKindCodes[MeasurementKindCodes["EndDeviceID"] = 102] = "EndDeviceID";
  MeasurementKindCodes[MeasurementKindCodes["GroupAddressType1"] = 103] = "GroupAddressType1";
  MeasurementKindCodes[MeasurementKindCodes["GroupAddressType2"] = 104] = "GroupAddressType2";
  MeasurementKindCodes[MeasurementKindCodes["GroupAddressType3"] = 105] = "GroupAddressType3";
  MeasurementKindCodes[MeasurementKindCodes["GroupAddressType4"] = 106] = "GroupAddressType4";
  MeasurementKindCodes[MeasurementKindCodes["IpAddress"] = 107] = "IpAddress";
  MeasurementKindCodes[MeasurementKindCodes["MacAddress"] = 108] = "MacAddress";
  MeasurementKindCodes[MeasurementKindCodes["MfgAssignedConfigurationID"] = 109] = "MfgAssignedConfigurationID";
  MeasurementKindCodes[MeasurementKindCodes["MfgAssignedPhysicalSerialNumber"] = 110] = "MfgAssignedPhysicalSerialNumber";
  MeasurementKindCodes[MeasurementKindCodes["MfgAssignedProductNumber"] = 111] = "MfgAssignedProductNumber";
  MeasurementKindCodes[MeasurementKindCodes["MfgAssignedUniqueCommunicationAddress"] = 112] = "MfgAssignedUniqueCommunicationAddress";
  MeasurementKindCodes[MeasurementKindCodes["MultiCastAddress"] = 113] = "MultiCastAddress";
  MeasurementKindCodes[MeasurementKindCodes["OneWayAddress"] = 114] = "OneWayAddress";
  MeasurementKindCodes[MeasurementKindCodes["SignalStrength"] = 115] = "SignalStrength";
  MeasurementKindCodes[MeasurementKindCodes["TwoWayAddress"] = 116] = "TwoWayAddress";
  MeasurementKindCodes[MeasurementKindCodes["SignaltoNoiseRatio"] = 117] = "SignaltoNoiseRatio";
  MeasurementKindCodes[MeasurementKindCodes["Alarm"] = 118] = "Alarm";
  MeasurementKindCodes[MeasurementKindCodes["BatteryCarryover"] = 119] = "BatteryCarryover";
  MeasurementKindCodes[MeasurementKindCodes["DataOverflowAlarm"] = 120] = "DataOverflowAlarm";
  MeasurementKindCodes[MeasurementKindCodes["DemandLimit"] = 121] = "DemandLimit";
  MeasurementKindCodes[MeasurementKindCodes["DemandReset"] = 122] = "DemandReset";
  MeasurementKindCodes[MeasurementKindCodes["Diagnostic"] = 123] = "Diagnostic";
  MeasurementKindCodes[MeasurementKindCodes["EmergencyLimit"] = 124] = "EmergencyLimit";
  MeasurementKindCodes[MeasurementKindCodes["EncoderTamper"] = 125] = "EncoderTamper";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366MomentaryInterruption"] = 126] = "Ieee1366MomentaryInterruption";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366MomentaryInterruptionEvent"] = 127] = "Ieee1366MomentaryInterruptionEvent";
  MeasurementKindCodes[MeasurementKindCodes["Ieee1366SustainedInterruption"] = 128] = "Ieee1366SustainedInterruption";
  MeasurementKindCodes[MeasurementKindCodes["InterruptionBehaviour"] = 129] = "InterruptionBehaviour";
  MeasurementKindCodes[MeasurementKindCodes["InversionTamper"] = 130] = "InversionTamper";
  MeasurementKindCodes[MeasurementKindCodes["LoadInterrupt"] = 131] = "LoadInterrupt";
  MeasurementKindCodes[MeasurementKindCodes["LoadShed"] = 132] = "LoadShed";
  MeasurementKindCodes[MeasurementKindCodes["Maintenance"] = 133] = "Maintenance";
  MeasurementKindCodes[MeasurementKindCodes["PhysicalTamper"] = 134] = "PhysicalTamper";
  MeasurementKindCodes[MeasurementKindCodes["PowerLossTamper"] = 135] = "PowerLossTamper";
  MeasurementKindCodes[MeasurementKindCodes["PowerOutage"] = 136] = "PowerOutage";
  MeasurementKindCodes[MeasurementKindCodes["PowerQuality"] = 137] = "PowerQuality";
  MeasurementKindCodes[MeasurementKindCodes["PowerRestoration"] = 138] = "PowerRestoration";
  MeasurementKindCodes[MeasurementKindCodes["Programmed"] = 139] = "Programmed";
  MeasurementKindCodes[MeasurementKindCodes["Pushbutton"] = 140] = "Pushbutton";
  MeasurementKindCodes[MeasurementKindCodes["RelayActivation"] = 141] = "RelayActivation";
  MeasurementKindCodes[MeasurementKindCodes["RelayCycle"] = 142] = "RelayCycle";
  MeasurementKindCodes[MeasurementKindCodes["RemovalTamper"] = 143] = "RemovalTamper";
  MeasurementKindCodes[MeasurementKindCodes["ReprogrammingTamper"] = 144] = "ReprogrammingTamper";
  MeasurementKindCodes[MeasurementKindCodes["ReverseRotationTamper"] = 145] = "ReverseRotationTamper";
  MeasurementKindCodes[MeasurementKindCodes["SwitchArmed"] = 146] = "SwitchArmed";
  MeasurementKindCodes[MeasurementKindCodes["SwitchDisabled"] = 147] = "SwitchDisabled";
  MeasurementKindCodes[MeasurementKindCodes["Tamper"] = 148] = "Tamper";
  MeasurementKindCodes[MeasurementKindCodes["WatchdogTimeout"] = 149] = "WatchdogTimeout";
  MeasurementKindCodes[MeasurementKindCodes["BillLastPeriod"] = 150] = "BillLastPeriod";
  MeasurementKindCodes[MeasurementKindCodes["BillToDate"] = 151] = "BillToDate";
  MeasurementKindCodes[MeasurementKindCodes["BillCarryover"] = 152] = "BillCarryover";
  MeasurementKindCodes[MeasurementKindCodes["ConnectionFee"] = 153] = "ConnectionFee";
  MeasurementKindCodes[MeasurementKindCodes["AudibleVolume"] = 154] = "AudibleVolume";
  MeasurementKindCodes[MeasurementKindCodes["VolumetricFlow"] = 155] = "VolumetricFlow";
  MeasurementKindCodes[MeasurementKindCodes["RelativeHumidity"] = 156] = "RelativeHumidity";
  MeasurementKindCodes[MeasurementKindCodes["SkyCover"] = 157] = "SkyCover";
  MeasurementKindCodes[MeasurementKindCodes["Voltage"] = 158] = "Voltage";
  MeasurementKindCodes[MeasurementKindCodes["DcVoltage"] = 159] = "DcVoltage";
  MeasurementKindCodes[MeasurementKindCodes["AcVoltagePeak"] = 160] = "AcVoltagePeak";
  MeasurementKindCodes[MeasurementKindCodes["AcVoltagePeakToPeak"] = 161] = "AcVoltagePeakToPeak";
  MeasurementKindCodes[MeasurementKindCodes["CustomMeasurementKind01"] = 162] = "CustomMeasurementKind01";
  MeasurementKindCodes[MeasurementKindCodes["CustomMeasurementKind02"] = 163] = "CustomMeasurementKind02";
  MeasurementKindCodes[MeasurementKindCodes["CustomMeasurementKind03"] = 164] = "CustomMeasurementKind03";
  MeasurementKindCodes[MeasurementKindCodes["CustomMeasurementKind04"] = 165] = "CustomMeasurementKind04";
})(MeasurementKindCodes || (MeasurementKindCodes = {}));

var MeasurementKindCodes$1 = MeasurementKindCodes;

var readingTypeInterharmonicCodes = {
  0: {
    0: 'None'
  },
  1: {
    2: 'Interharmonic1_2',
    1: 'Fundamental'
  },
  2: {
    1: 'Harmonic2'
  },
  3: {
    1: 'Harmonic3'
  },
  4: {
    1: 'Harmonic4'
  },
  5: {
    1: 'Harmonic5'
  },
  6: {
    1: 'Harmonic6'
  },
  7: {
    1: 'Harmonic7'
  }
};

var readingTypeInterharmonic = function readingTypeInterharmonic(code1, code2) {
  return readingTypeInterharmonicCodes[code1] ? readingTypeInterharmonicCodes[code1][code2] : undefined;
};

var readingTypeArgumentCodes = {
  0: {
    0: 'None',
    1: 'N0'
  },
  1: {
    1: 'N1',
    2: 'N1_2'
  },
  2: {
    1: 'N2'
  },
  3: {
    1: 'N3'
  },
  4: {
    1: 'N4'
  },
  5: {
    1: 'N5'
  },
  6: {
    1: 'N6'
  },
  7: {
    1: 'N7'
  },
  8: {
    1: 'N8'
  },
  9: {
    1: 'N9'
  },
  10: {
    1: 'N10'
  },
  15: {
    1: 'N15'
  },
  30: {
    1: 'N30'
  },
  45: {
    1: 'N45'
  },
  60: {
    1: 'N60'
  },
  120: {
    1: 'N120'
  },
  155: {
    1: 'N155'
  },
  240: {
    1: 'N240'
  },
  305: {
    1: 'N305'
  },
  360: {
    1: 'N360'
  },
  480: {
    1: 'N480'
  },
  720: {
    1: 'N720',
    60: 'N720_60',
    120: 'N720_120',
    180: 'N720_180',
    240: 'N720_240',
    360: 'N720_360'
  }
};

var readingTypeArgument = function readingTypeArgument(code1, code2) {
  return readingTypeArgumentCodes[code1] ? readingTypeArgumentCodes[code1][code2] : undefined;
};

var TimeOfUseCodes;

(function (TimeOfUseCodes) {
  TimeOfUseCodes[TimeOfUseCodes["None"] = 0] = "None";
  TimeOfUseCodes[TimeOfUseCodes["TouA"] = 1] = "TouA";
  TimeOfUseCodes[TimeOfUseCodes["TouB"] = 2] = "TouB";
  TimeOfUseCodes[TimeOfUseCodes["TouC"] = 3] = "TouC";
  TimeOfUseCodes[TimeOfUseCodes["TouD"] = 4] = "TouD";
  TimeOfUseCodes[TimeOfUseCodes["TouE"] = 5] = "TouE";
  TimeOfUseCodes[TimeOfUseCodes["TouF"] = 6] = "TouF";
  TimeOfUseCodes[TimeOfUseCodes["TouG"] = 7] = "TouG";
})(TimeOfUseCodes || (TimeOfUseCodes = {}));

var TimeOfUseCodes$1 = TimeOfUseCodes;

var CriticalPeakPeriodCodes;

(function (CriticalPeakPeriodCodes) {
  CriticalPeakPeriodCodes[CriticalPeakPeriodCodes["None"] = 0] = "None";
  CriticalPeakPeriodCodes[CriticalPeakPeriodCodes["CppA"] = 1] = "CppA";
  CriticalPeakPeriodCodes[CriticalPeakPeriodCodes["CppB"] = 2] = "CppB";
  CriticalPeakPeriodCodes[CriticalPeakPeriodCodes["CppC"] = 3] = "CppC";
  CriticalPeakPeriodCodes[CriticalPeakPeriodCodes["CppD"] = 4] = "CppD";
  CriticalPeakPeriodCodes[CriticalPeakPeriodCodes["CppE"] = 5] = "CppE";
  CriticalPeakPeriodCodes[CriticalPeakPeriodCodes["CppF"] = 6] = "CppF";
  CriticalPeakPeriodCodes[CriticalPeakPeriodCodes["CppG"] = 7] = "CppG";
})(CriticalPeakPeriodCodes || (CriticalPeakPeriodCodes = {}));

var CriticalPeakPeriodCodes$1 = CriticalPeakPeriodCodes;

var ConsumptionTierCodes;

(function (ConsumptionTierCodes) {
  ConsumptionTierCodes[ConsumptionTierCodes["None"] = 0] = "None";
  ConsumptionTierCodes[ConsumptionTierCodes["ConsumptionTier1"] = 1] = "ConsumptionTier1";
  ConsumptionTierCodes[ConsumptionTierCodes["ConsumptionTier2"] = 2] = "ConsumptionTier2";
  ConsumptionTierCodes[ConsumptionTierCodes["ConsumptionTier3"] = 3] = "ConsumptionTier3";
  ConsumptionTierCodes[ConsumptionTierCodes["ConsumptionTier4"] = 4] = "ConsumptionTier4";
  ConsumptionTierCodes[ConsumptionTierCodes["ConsumptionTier5"] = 5] = "ConsumptionTier5";
  ConsumptionTierCodes[ConsumptionTierCodes["ConsumptionTier6"] = 6] = "ConsumptionTier6";
  ConsumptionTierCodes[ConsumptionTierCodes["ConsumptionTier7"] = 7] = "ConsumptionTier7";
})(ConsumptionTierCodes || (ConsumptionTierCodes = {}));

var ConsumptionTierCodes$1 = ConsumptionTierCodes;

var PhaseCodes;

(function (PhaseCodes) {
  PhaseCodes[PhaseCodes["None"] = 0] = "None";
  PhaseCodes[PhaseCodes["PhaseN"] = 16] = "PhaseN";
  PhaseCodes[PhaseCodes["PhaseNtoGnd"] = 17] = "PhaseNtoGnd";
  PhaseCodes[PhaseCodes["PhaseC"] = 32] = "PhaseC";
  PhaseCodes[PhaseCodes["PhaseCtoN"] = 33] = "PhaseCtoN";
  PhaseCodes[PhaseCodes["PhaseCtoAv"] = 40] = "PhaseCtoAv";
  PhaseCodes[PhaseCodes["PhaseCAtoN"] = 41] = "PhaseCAtoN";
  PhaseCodes[PhaseCodes["PhaseB"] = 64] = "PhaseB";
  PhaseCodes[PhaseCodes["PhaseBtoN"] = 65] = "PhaseBtoN";
  PhaseCodes[PhaseCodes["PhaseBtoC"] = 66] = "PhaseBtoC";
  PhaseCodes[PhaseCodes["PhaseBtoAv"] = 72] = "PhaseBtoAv";
  PhaseCodes[PhaseCodes["PhaseBCtoN"] = 97] = "PhaseBCtoN";
  PhaseCodes[PhaseCodes["PhaseA"] = 128] = "PhaseA";
  PhaseCodes[PhaseCodes["PhaseAtoN"] = 129] = "PhaseAtoN";
  PhaseCodes[PhaseCodes["PhaseAtoB"] = 132] = "PhaseAtoB";
  PhaseCodes[PhaseCodes["PhaseAtoAv"] = 136] = "PhaseAtoAv";
  PhaseCodes[PhaseCodes["PhaseABtoN"] = 193] = "PhaseABtoN";
  PhaseCodes[PhaseCodes["PhasesABC"] = 224] = "PhasesABC";
  PhaseCodes[PhaseCodes["PhaseABCtoN"] = 225] = "PhaseABCtoN";
  PhaseCodes[PhaseCodes["S2"] = 256] = "S2";
  PhaseCodes[PhaseCodes["S2N"] = 257] = "S2N";
  PhaseCodes[PhaseCodes["S1"] = 512] = "S1";
  PhaseCodes[PhaseCodes["S1N"] = 513] = "S1N";
  PhaseCodes[PhaseCodes["S12"] = 768] = "S12";
  PhaseCodes[PhaseCodes["S12N"] = 769] = "S12N";
  PhaseCodes[PhaseCodes["ThreeWireWye"] = 1248] = "ThreeWireWye";
  PhaseCodes[PhaseCodes["FourWireWye"] = 1249] = "FourWireWye";
  PhaseCodes[PhaseCodes["ThreeWireDelta"] = 2272] = "ThreeWireDelta";
  PhaseCodes[PhaseCodes["FourWireDelta"] = 2273] = "FourWireDelta";
  PhaseCodes[PhaseCodes["FourWireHLDelta"] = 6369] = "FourWireHLDelta";
  PhaseCodes[PhaseCodes["FourWireOpenDelta"] = 10465] = "FourWireOpenDelta";
  PhaseCodes[PhaseCodes["Networked"] = 17153] = "Networked";
})(PhaseCodes || (PhaseCodes = {}));

var PhaseCodes$1 = PhaseCodes;

var readingTypeMultiplierCodes = {
  0: {
    value: 'None',
    symbol: ''
  },
  '-24': {
    value: 'Ycto',
    symbol: 'y'
  },
  '-21': {
    value: 'Zepto',
    symbol: 'z'
  },
  '-18': {
    value: 'Atto',
    symbol: 'a'
  },
  '-15': {
    value: 'Femto',
    symbol: 'f'
  },
  '-12': {
    value: 'Pico',
    symbol: 'p'
  },
  '-9': {
    value: 'Nano',
    symbol: 'n'
  },
  '-6': {
    value: 'Micro',
    symbol: 'μ'
  },
  '-3': {
    value: 'Milli',
    symbol: 'm'
  },
  '-2': {
    value: 'Centi',
    symbol: 'c'
  },
  '-1': {
    value: 'Deci',
    symbol: 'd'
  },
  1: {
    value: 'Deca',
    symbol: 'da'
  },
  2: {
    value: 'Hecto',
    symbol: 'h'
  },
  3: {
    value: 'Kilo',
    symbol: 'k'
  },
  6: {
    value: 'Mega',
    symbol: 'M'
  },
  9: {
    value: 'Giga',
    symbol: 'G'
  },
  12: {
    value: 'Tera',
    symbol: 'T'
  },
  15: {
    value: 'Peta',
    symbol: 'P'
  },
  18: {
    value: 'Exa',
    symbol: 'E'
  },
  21: {
    value: 'Zetta',
    symbol: 'Z'
  },
  24: {
    value: 'Yotta',
    symbol: 'Y'
  }
};

var readingTypeMultiplier = function readingTypeMultiplier(code) {
  return readingTypeMultiplierCodes[code];
};

var UnitCodes;

(function (UnitCodes) {
  UnitCodes[UnitCodes["None"] = 0] = "None";
  UnitCodes[UnitCodes["M"] = 2] = "M";
  UnitCodes[UnitCodes["G"] = 3] = "G";
  UnitCodes[UnitCodes["A"] = 5] = "A";
  UnitCodes[UnitCodes["DegK"] = 6] = "DegK";
  UnitCodes[UnitCodes["Mol"] = 7] = "Mol";
  UnitCodes[UnitCodes["Cd"] = 8] = "Cd";
  UnitCodes[UnitCodes["S"] = 27] = "S";
  UnitCodes[UnitCodes["Rad"] = 10] = "Rad";
  UnitCodes[UnitCodes["Sr"] = 11] = "Sr";
  UnitCodes[UnitCodes["Gy"] = 21] = "Gy";
  UnitCodes[UnitCodes["Bq"] = 22] = "Bq";
  UnitCodes[UnitCodes["DegC"] = 23] = "DegC";
  UnitCodes[UnitCodes["Sv"] = 24] = "Sv";
  UnitCodes[UnitCodes["F"] = 25] = "F";
  UnitCodes[UnitCodes["C"] = 26] = "C";
  UnitCodes[UnitCodes["H"] = 28] = "H";
  UnitCodes[UnitCodes["V"] = 29] = "V";
  UnitCodes[UnitCodes["Ohm"] = 30] = "Ohm";
  UnitCodes[UnitCodes["J"] = 31] = "J";
  UnitCodes[UnitCodes["N"] = 32] = "N";
  UnitCodes[UnitCodes["Hz"] = 33] = "Hz";
  UnitCodes[UnitCodes["Lx"] = 34] = "Lx";
  UnitCodes[UnitCodes["Lm"] = 35] = "Lm";
  UnitCodes[UnitCodes["Wb"] = 36] = "Wb";
  UnitCodes[UnitCodes["T"] = 37] = "T";
  UnitCodes[UnitCodes["W"] = 38] = "W";
  UnitCodes[UnitCodes["Pa"] = 39] = "Pa";
  UnitCodes[UnitCodes["Siemens"] = 53] = "Siemens";
  UnitCodes[UnitCodes["PaA"] = 155] = "PaA";
  UnitCodes[UnitCodes["PaG"] = 140] = "PaG";
  UnitCodes[UnitCodes["Kat"] = 158] = "Kat";
  UnitCodes[UnitCodes["RevPerS"] = 4] = "RevPerS";
  UnitCodes[UnitCodes["M2"] = 41] = "M2";
  UnitCodes[UnitCodes["M3"] = 42] = "M3";
  UnitCodes[UnitCodes["MPerS"] = 43] = "MPerS";
  UnitCodes[UnitCodes["MPerS2"] = 44] = "MPerS2";
  UnitCodes[UnitCodes["M3PerS"] = 45] = "M3PerS";
  UnitCodes[UnitCodes["MPerM3"] = 46] = "MPerM3";
  UnitCodes[UnitCodes["GM"] = 47] = "GM";
  UnitCodes[UnitCodes["GPerM3"] = 48] = "GPerM3";
  UnitCodes[UnitCodes["M2PerS"] = 49] = "M2PerS";
  UnitCodes[UnitCodes["WPerMK"] = 50] = "WPerMK";
  UnitCodes[UnitCodes["JPerK"] = 51] = "JPerK";
  UnitCodes[UnitCodes["RadPerS"] = 54] = "RadPerS";
  UnitCodes[UnitCodes["VA"] = 61] = "VA";
  UnitCodes[UnitCodes["VAr"] = 63] = "VAr";
  UnitCodes[UnitCodes["VS"] = 66] = "VS";
  UnitCodes[UnitCodes["V2"] = 67] = "V2";
  UnitCodes[UnitCodes["As"] = 68] = "As";
  UnitCodes[UnitCodes["A2"] = 69] = "A2";
  UnitCodes[UnitCodes["A2s"] = 70] = "A2s";
  UnitCodes[UnitCodes["VAH"] = 71] = "VAH";
  UnitCodes[UnitCodes["WH"] = 72] = "WH";
  UnitCodes[UnitCodes["VArH"] = 73] = "VArH";
  UnitCodes[UnitCodes["VPerHz"] = 74] = "VPerHz";
  UnitCodes[UnitCodes["HzPerS"] = 75] = "HzPerS";
  UnitCodes[UnitCodes["GM2"] = 78] = "GM2";
  UnitCodes[UnitCodes["WPerS"] = 81] = "WPerS";
  UnitCodes[UnitCodes["LPerS"] = 82] = "LPerS";
  UnitCodes[UnitCodes["Q"] = 100] = "Q";
  UnitCodes[UnitCodes["Qh"] = 101] = "Qh";
  UnitCodes[UnitCodes["OhmM"] = 102] = "OhmM";
  UnitCodes[UnitCodes["APerM"] = 103] = "APerM";
  UnitCodes[UnitCodes["V2H"] = 104] = "V2H";
  UnitCodes[UnitCodes["A2H"] = 105] = "A2H";
  UnitCodes[UnitCodes["AH"] = 106] = "AH";
  UnitCodes[UnitCodes["WHPerM3"] = 107] = "WHPerM3";
  UnitCodes[UnitCodes["TimeStamp"] = 108] = "TimeStamp";
  UnitCodes[UnitCodes["WHPerRev"] = 115] = "WHPerRev";
  UnitCodes[UnitCodes["VArHPerRev"] = 116] = "VArHPerRev";
  UnitCodes[UnitCodes["VAHPerRev"] = 117] = "VAHPerRev";
  UnitCodes[UnitCodes["M3PerH"] = 125] = "M3PerH";
  UnitCodes[UnitCodes["M3CompensatedPerH"] = 126] = "M3CompensatedPerH";
  UnitCodes[UnitCodes["M3UncompensatedPerH"] = 127] = "M3UncompensatedPerH";
  UnitCodes[UnitCodes["LPerH"] = 137] = "LPerH";
  UnitCodes[UnitCodes["LCompensatedPerH"] = 138] = "LCompensatedPerH";
  UnitCodes[UnitCodes["LUncompensatedPerH"] = 139] = "LUncompensatedPerH";
  UnitCodes[UnitCodes["Q45"] = 161] = "Q45";
  UnitCodes[UnitCodes["Q60"] = 162] = "Q60";
  UnitCodes[UnitCodes["Q45H"] = 163] = "Q45H";
  UnitCodes[UnitCodes["Q60H"] = 164] = "Q60H";
  UnitCodes[UnitCodes["JPerKg"] = 165] = "JPerKg";
  UnitCodes[UnitCodes["M3Uncompensated"] = 166] = "M3Uncompensated";
  UnitCodes[UnitCodes["M3Compensated"] = 167] = "M3Compensated";
  UnitCodes[UnitCodes["M1"] = 173] = "M1";
  UnitCodes[UnitCodes["M3PerKg"] = 174] = "M3PerKg";
  UnitCodes[UnitCodes["PaS"] = 175] = "PaS";
  UnitCodes[UnitCodes["NM"] = 176] = "NM";
  UnitCodes[UnitCodes["NPerM"] = 177] = "NPerM";
  UnitCodes[UnitCodes["RadPerS2"] = 178] = "RadPerS2";
  UnitCodes[UnitCodes["WPerM2"] = 179] = "WPerM2";
  UnitCodes[UnitCodes["JPerKgK"] = 180] = "JPerKgK";
  UnitCodes[UnitCodes["JPerM3"] = 181] = "JPerM3";
  UnitCodes[UnitCodes["VPerM"] = 182] = "VPerM";
  UnitCodes[UnitCodes["CPerM3"] = 183] = "CPerM3";
  UnitCodes[UnitCodes["CPerM2"] = 184] = "CPerM2";
  UnitCodes[UnitCodes["FPerM"] = 185] = "FPerM";
  UnitCodes[UnitCodes["HPerM"] = 186] = "HPerM";
  UnitCodes[UnitCodes["JPerMol"] = 187] = "JPerMol";
  UnitCodes[UnitCodes["JPerMolK"] = 188] = "JPerMolK";
  UnitCodes[UnitCodes["CPerKg"] = 189] = "CPerKg";
  UnitCodes[UnitCodes["GyPerS"] = 190] = "GyPerS";
  UnitCodes[UnitCodes["WPerSr"] = 191] = "WPerSr";
  UnitCodes[UnitCodes["WPerM2Sr"] = 192] = "WPerM2Sr";
  UnitCodes[UnitCodes["KatPerM3"] = 193] = "KatPerM3";
  UnitCodes[UnitCodes["VH"] = 280] = "VH";
  UnitCodes[UnitCodes["Min"] = 159] = "Min";
  UnitCodes[UnitCodes["Hr"] = 160] = "Hr";
  UnitCodes[UnitCodes["D"] = 195] = "D";
  UnitCodes[UnitCodes["Deg"] = 9] = "Deg";
  UnitCodes[UnitCodes["AngleMin"] = 196] = "AngleMin";
  UnitCodes[UnitCodes["AngleSec"] = 197] = "AngleSec";
  UnitCodes[UnitCodes["Ha"] = 198] = "Ha";
  UnitCodes[UnitCodes["L"] = 134] = "L";
  UnitCodes[UnitCodes["Tonne"] = 199] = "Tonne";
  UnitCodes[UnitCodes["CosTheta"] = 65] = "CosTheta";
  UnitCodes[UnitCodes["Bel"] = 79] = "Bel";
  UnitCodes[UnitCodes["Status"] = 109] = "Status";
  UnitCodes[UnitCodes["Count"] = 111] = "Count";
  UnitCodes[UnitCodes["Bm"] = 113] = "Bm";
  UnitCodes[UnitCodes["Code"] = 114] = "Code";
  UnitCodes[UnitCodes["MeCode"] = 118] = "MeCode";
  UnitCodes[UnitCodes["LPerL"] = 143] = "LPerL";
  UnitCodes[UnitCodes["GPerG"] = 144] = "GPerG";
  UnitCodes[UnitCodes["MolPerM3"] = 145] = "MolPerM3";
  UnitCodes[UnitCodes["MolPerMol"] = 146] = "MolPerMol";
  UnitCodes[UnitCodes["MolPerKg"] = 147] = "MolPerKg";
  UnitCodes[UnitCodes["MPerM"] = 148] = "MPerM";
  UnitCodes[UnitCodes["SPerS"] = 149] = "SPerS";
  UnitCodes[UnitCodes["HzPerHz"] = 150] = "HzPerHz";
  UnitCodes[UnitCodes["VPerV"] = 151] = "VPerV";
  UnitCodes[UnitCodes["APerA"] = 152] = "APerA";
  UnitCodes[UnitCodes["WPerVA"] = 153] = "WPerVA";
  UnitCodes[UnitCodes["Rev"] = 154] = "Rev";
  UnitCodes[UnitCodes["WPerW"] = 168] = "WPerW";
  UnitCodes[UnitCodes["RefractiveIndexN"] = 170] = "RefractiveIndexN";
  UnitCodes[UnitCodes["RelativePermeabilityMur"] = 171] = "RelativePermeabilityMur";
  UnitCodes[UnitCodes["Np"] = 172] = "Np";
  UnitCodes[UnitCodes["RelativeHumidity"] = 281] = "RelativeHumidity";
  UnitCodes[UnitCodes["SkyCover"] = 282] = "SkyCover";
})(UnitCodes || (UnitCodes = {}));

var UnitCodes$1 = UnitCodes;

var CurrencyCodes;

(function (CurrencyCodes) {
  CurrencyCodes[CurrencyCodes["None"] = 0] = "None";
  CurrencyCodes[CurrencyCodes["AED"] = 784] = "AED";
  CurrencyCodes[CurrencyCodes["AFN"] = 971] = "AFN";
  CurrencyCodes[CurrencyCodes["ALL"] = 8] = "ALL";
  CurrencyCodes[CurrencyCodes["AMD"] = 51] = "AMD";
  CurrencyCodes[CurrencyCodes["ANG"] = 532] = "ANG";
  CurrencyCodes[CurrencyCodes["AOA"] = 973] = "AOA";
  CurrencyCodes[CurrencyCodes["ARS"] = 32] = "ARS";
  CurrencyCodes[CurrencyCodes["AUD"] = 36] = "AUD";
  CurrencyCodes[CurrencyCodes["AWG"] = 533] = "AWG";
  CurrencyCodes[CurrencyCodes["AZN"] = 944] = "AZN";
  CurrencyCodes[CurrencyCodes["BAM"] = 977] = "BAM";
  CurrencyCodes[CurrencyCodes["BBD"] = 52] = "BBD";
  CurrencyCodes[CurrencyCodes["BDT"] = 50] = "BDT";
  CurrencyCodes[CurrencyCodes["BGN"] = 975] = "BGN";
  CurrencyCodes[CurrencyCodes["BHD"] = 48] = "BHD";
  CurrencyCodes[CurrencyCodes["BIF"] = 108] = "BIF";
  CurrencyCodes[CurrencyCodes["BMD"] = 60] = "BMD";
  CurrencyCodes[CurrencyCodes["BND"] = 96] = "BND";
  CurrencyCodes[CurrencyCodes["BOB"] = 68] = "BOB";
  CurrencyCodes[CurrencyCodes["BOV"] = 984] = "BOV";
  CurrencyCodes[CurrencyCodes["BRL"] = 986] = "BRL";
  CurrencyCodes[CurrencyCodes["BSD"] = 44] = "BSD";
  CurrencyCodes[CurrencyCodes["BTN"] = 64] = "BTN";
  CurrencyCodes[CurrencyCodes["BWP"] = 72] = "BWP";
  CurrencyCodes[CurrencyCodes["BYN"] = 933] = "BYN";
  CurrencyCodes[CurrencyCodes["BZD"] = 84] = "BZD";
  CurrencyCodes[CurrencyCodes["CAD"] = 124] = "CAD";
  CurrencyCodes[CurrencyCodes["CDF"] = 976] = "CDF";
  CurrencyCodes[CurrencyCodes["CHE"] = 947] = "CHE";
  CurrencyCodes[CurrencyCodes["CHF"] = 756] = "CHF";
  CurrencyCodes[CurrencyCodes["CHW"] = 948] = "CHW";
  CurrencyCodes[CurrencyCodes["CLF"] = 990] = "CLF";
  CurrencyCodes[CurrencyCodes["CLP"] = 152] = "CLP";
  CurrencyCodes[CurrencyCodes["CNY"] = 156] = "CNY";
  CurrencyCodes[CurrencyCodes["COP"] = 170] = "COP";
  CurrencyCodes[CurrencyCodes["COU"] = 970] = "COU";
  CurrencyCodes[CurrencyCodes["CRC"] = 188] = "CRC";
  CurrencyCodes[CurrencyCodes["CUC"] = 931] = "CUC";
  CurrencyCodes[CurrencyCodes["CUP"] = 192] = "CUP";
  CurrencyCodes[CurrencyCodes["CVE"] = 132] = "CVE";
  CurrencyCodes[CurrencyCodes["CZK"] = 203] = "CZK";
  CurrencyCodes[CurrencyCodes["DJF"] = 262] = "DJF";
  CurrencyCodes[CurrencyCodes["DKK"] = 208] = "DKK";
  CurrencyCodes[CurrencyCodes["DOP"] = 214] = "DOP";
  CurrencyCodes[CurrencyCodes["DZD"] = 12] = "DZD";
  CurrencyCodes[CurrencyCodes["EGP"] = 818] = "EGP";
  CurrencyCodes[CurrencyCodes["ERN"] = 232] = "ERN";
  CurrencyCodes[CurrencyCodes["ETB"] = 230] = "ETB";
  CurrencyCodes[CurrencyCodes["EUR"] = 978] = "EUR";
  CurrencyCodes[CurrencyCodes["FJD"] = 242] = "FJD";
  CurrencyCodes[CurrencyCodes["FKP"] = 238] = "FKP";
  CurrencyCodes[CurrencyCodes["GBP"] = 826] = "GBP";
  CurrencyCodes[CurrencyCodes["GEL"] = 981] = "GEL";
  CurrencyCodes[CurrencyCodes["GHS"] = 936] = "GHS";
  CurrencyCodes[CurrencyCodes["GIP"] = 292] = "GIP";
  CurrencyCodes[CurrencyCodes["GMD"] = 270] = "GMD";
  CurrencyCodes[CurrencyCodes["GNF"] = 324] = "GNF";
  CurrencyCodes[CurrencyCodes["GTQ"] = 320] = "GTQ";
  CurrencyCodes[CurrencyCodes["GYD"] = 328] = "GYD";
  CurrencyCodes[CurrencyCodes["HKD"] = 344] = "HKD";
  CurrencyCodes[CurrencyCodes["HNL"] = 340] = "HNL";
  CurrencyCodes[CurrencyCodes["HRK"] = 191] = "HRK";
  CurrencyCodes[CurrencyCodes["HTG"] = 332] = "HTG";
  CurrencyCodes[CurrencyCodes["HUF"] = 348] = "HUF";
  CurrencyCodes[CurrencyCodes["IDR"] = 360] = "IDR";
  CurrencyCodes[CurrencyCodes["ILS"] = 376] = "ILS";
  CurrencyCodes[CurrencyCodes["INR"] = 356] = "INR";
  CurrencyCodes[CurrencyCodes["IQD"] = 368] = "IQD";
  CurrencyCodes[CurrencyCodes["IRR"] = 364] = "IRR";
  CurrencyCodes[CurrencyCodes["ISK"] = 352] = "ISK";
  CurrencyCodes[CurrencyCodes["JMD"] = 388] = "JMD";
  CurrencyCodes[CurrencyCodes["JOD"] = 400] = "JOD";
  CurrencyCodes[CurrencyCodes["JPY"] = 392] = "JPY";
  CurrencyCodes[CurrencyCodes["KES"] = 404] = "KES";
  CurrencyCodes[CurrencyCodes["KGS"] = 417] = "KGS";
  CurrencyCodes[CurrencyCodes["KHR"] = 116] = "KHR";
  CurrencyCodes[CurrencyCodes["KMF"] = 174] = "KMF";
  CurrencyCodes[CurrencyCodes["KPW"] = 408] = "KPW";
  CurrencyCodes[CurrencyCodes["KRW"] = 410] = "KRW";
  CurrencyCodes[CurrencyCodes["KWD"] = 414] = "KWD";
  CurrencyCodes[CurrencyCodes["KYD"] = 136] = "KYD";
  CurrencyCodes[CurrencyCodes["KZT"] = 398] = "KZT";
  CurrencyCodes[CurrencyCodes["LAK"] = 418] = "LAK";
  CurrencyCodes[CurrencyCodes["LBP"] = 422] = "LBP";
  CurrencyCodes[CurrencyCodes["LKR"] = 144] = "LKR";
  CurrencyCodes[CurrencyCodes["LRD"] = 430] = "LRD";
  CurrencyCodes[CurrencyCodes["LSL"] = 426] = "LSL";
  CurrencyCodes[CurrencyCodes["LYD"] = 434] = "LYD";
  CurrencyCodes[CurrencyCodes["MAD"] = 504] = "MAD";
  CurrencyCodes[CurrencyCodes["MDL"] = 498] = "MDL";
  CurrencyCodes[CurrencyCodes["MGA"] = 969] = "MGA";
  CurrencyCodes[CurrencyCodes["MKD"] = 807] = "MKD";
  CurrencyCodes[CurrencyCodes["MMK"] = 104] = "MMK";
  CurrencyCodes[CurrencyCodes["MNT"] = 496] = "MNT";
  CurrencyCodes[CurrencyCodes["MOP"] = 446] = "MOP";
  CurrencyCodes[CurrencyCodes["MRU"] = 929] = "MRU";
  CurrencyCodes[CurrencyCodes["MUR"] = 480] = "MUR";
  CurrencyCodes[CurrencyCodes["MVR"] = 462] = "MVR";
  CurrencyCodes[CurrencyCodes["MWK"] = 545] = "MWK";
  CurrencyCodes[CurrencyCodes["MXN"] = 484] = "MXN";
  CurrencyCodes[CurrencyCodes["MXV"] = 979] = "MXV";
  CurrencyCodes[CurrencyCodes["MYR"] = 458] = "MYR";
  CurrencyCodes[CurrencyCodes["MZN"] = 943] = "MZN";
  CurrencyCodes[CurrencyCodes["NAD"] = 516] = "NAD";
  CurrencyCodes[CurrencyCodes["NGN"] = 566] = "NGN";
  CurrencyCodes[CurrencyCodes["NIO"] = 558] = "NIO";
  CurrencyCodes[CurrencyCodes["NOK"] = 578] = "NOK";
  CurrencyCodes[CurrencyCodes["NPR"] = 524] = "NPR";
  CurrencyCodes[CurrencyCodes["NZD"] = 554] = "NZD";
  CurrencyCodes[CurrencyCodes["OMR"] = 512] = "OMR";
  CurrencyCodes[CurrencyCodes["PAB"] = 590] = "PAB";
  CurrencyCodes[CurrencyCodes["PEN"] = 604] = "PEN";
  CurrencyCodes[CurrencyCodes["PGK"] = 598] = "PGK";
  CurrencyCodes[CurrencyCodes["PHP"] = 608] = "PHP";
  CurrencyCodes[CurrencyCodes["PKR"] = 586] = "PKR";
  CurrencyCodes[CurrencyCodes["PLN"] = 985] = "PLN";
  CurrencyCodes[CurrencyCodes["PYG"] = 600] = "PYG";
  CurrencyCodes[CurrencyCodes["QAR"] = 634] = "QAR";
  CurrencyCodes[CurrencyCodes["RON"] = 946] = "RON";
  CurrencyCodes[CurrencyCodes["RSD"] = 941] = "RSD";
  CurrencyCodes[CurrencyCodes["RUB"] = 643] = "RUB";
  CurrencyCodes[CurrencyCodes["RWF"] = 646] = "RWF";
  CurrencyCodes[CurrencyCodes["SAR"] = 682] = "SAR";
  CurrencyCodes[CurrencyCodes["SBD"] = 90] = "SBD";
  CurrencyCodes[CurrencyCodes["SCR"] = 690] = "SCR";
  CurrencyCodes[CurrencyCodes["SDG"] = 938] = "SDG";
  CurrencyCodes[CurrencyCodes["SEK"] = 752] = "SEK";
  CurrencyCodes[CurrencyCodes["SGD"] = 702] = "SGD";
  CurrencyCodes[CurrencyCodes["SHP"] = 654] = "SHP";
  CurrencyCodes[CurrencyCodes["SLL"] = 694] = "SLL";
  CurrencyCodes[CurrencyCodes["SOS"] = 706] = "SOS";
  CurrencyCodes[CurrencyCodes["SRD"] = 968] = "SRD";
  CurrencyCodes[CurrencyCodes["SSP"] = 728] = "SSP";
  CurrencyCodes[CurrencyCodes["STN"] = 930] = "STN";
  CurrencyCodes[CurrencyCodes["SVC"] = 222] = "SVC";
  CurrencyCodes[CurrencyCodes["SYP"] = 760] = "SYP";
  CurrencyCodes[CurrencyCodes["SZL"] = 748] = "SZL";
  CurrencyCodes[CurrencyCodes["THB"] = 764] = "THB";
  CurrencyCodes[CurrencyCodes["TJS"] = 972] = "TJS";
  CurrencyCodes[CurrencyCodes["TMT"] = 934] = "TMT";
  CurrencyCodes[CurrencyCodes["TND"] = 788] = "TND";
  CurrencyCodes[CurrencyCodes["TOP"] = 776] = "TOP";
  CurrencyCodes[CurrencyCodes["TRY"] = 949] = "TRY";
  CurrencyCodes[CurrencyCodes["TTD"] = 780] = "TTD";
  CurrencyCodes[CurrencyCodes["TWD"] = 901] = "TWD";
  CurrencyCodes[CurrencyCodes["TZS"] = 834] = "TZS";
  CurrencyCodes[CurrencyCodes["UAH"] = 980] = "UAH";
  CurrencyCodes[CurrencyCodes["UGX"] = 800] = "UGX";
  CurrencyCodes[CurrencyCodes["USD"] = 840] = "USD";
  CurrencyCodes[CurrencyCodes["USN"] = 997] = "USN";
  CurrencyCodes[CurrencyCodes["UYI"] = 940] = "UYI";
  CurrencyCodes[CurrencyCodes["UYU"] = 858] = "UYU";
  CurrencyCodes[CurrencyCodes["UYW"] = 927] = "UYW";
  CurrencyCodes[CurrencyCodes["UZS"] = 860] = "UZS";
  CurrencyCodes[CurrencyCodes["VES"] = 928] = "VES";
  CurrencyCodes[CurrencyCodes["VND"] = 704] = "VND";
  CurrencyCodes[CurrencyCodes["VUV"] = 548] = "VUV";
  CurrencyCodes[CurrencyCodes["WST"] = 882] = "WST";
  CurrencyCodes[CurrencyCodes["XAF"] = 950] = "XAF";
  CurrencyCodes[CurrencyCodes["XAG"] = 961] = "XAG";
  CurrencyCodes[CurrencyCodes["XAU"] = 959] = "XAU";
  CurrencyCodes[CurrencyCodes["XBA"] = 955] = "XBA";
  CurrencyCodes[CurrencyCodes["XBB"] = 956] = "XBB";
  CurrencyCodes[CurrencyCodes["XBC"] = 957] = "XBC";
  CurrencyCodes[CurrencyCodes["XBD"] = 958] = "XBD";
  CurrencyCodes[CurrencyCodes["XCD"] = 951] = "XCD";
  CurrencyCodes[CurrencyCodes["XDR"] = 960] = "XDR";
  CurrencyCodes[CurrencyCodes["XOF"] = 952] = "XOF";
  CurrencyCodes[CurrencyCodes["XPD"] = 964] = "XPD";
  CurrencyCodes[CurrencyCodes["XPF"] = 953] = "XPF";
  CurrencyCodes[CurrencyCodes["XPT"] = 962] = "XPT";
  CurrencyCodes[CurrencyCodes["XSU"] = 994] = "XSU";
  CurrencyCodes[CurrencyCodes["XTS"] = 963] = "XTS";
  CurrencyCodes[CurrencyCodes["XUA"] = 965] = "XUA";
  CurrencyCodes[CurrencyCodes["XXX"] = 999] = "XXX";
  CurrencyCodes[CurrencyCodes["YER"] = 886] = "YER";
  CurrencyCodes[CurrencyCodes["ZAR"] = 710] = "ZAR";
  CurrencyCodes[CurrencyCodes["ZMW"] = 967] = "ZMW";
})(CurrencyCodes || (CurrencyCodes = {}));

var CurrencyCodes$1 = CurrencyCodes;

var Codes = {
  MacroPeriodCodes: MacroPeriodCodes$1,
  AggregateCodes: AggregateCodes$1,
  MeasuringPeriodCodes: MeasuringPeriodCodes$1,
  AccumulationCodes: AccumulationCodes$1,
  FlowDirectionCodes: FlowDirectionCodes$1,
  CommodityCodes: CommodityCodes$1,
  MeasurementKindCodes: MeasurementKindCodes$1,
  interharmonicCodes: readingTypeInterharmonic,
  argumentCodes: readingTypeArgument,
  TimeOfUseCodes: TimeOfUseCodes$1,
  CriticalPeakPeriodCodes: CriticalPeakPeriodCodes$1,
  ConsumptionTierCodes: ConsumptionTierCodes$1,
  PhaseCodes: PhaseCodes$1,
  multiplierCodes: readingTypeMultiplier,
  UnitCodes: UnitCodes$1,
  CurrencyCodes: CurrencyCodes$1
};

var ReadingType = function ReadingType(_ref) {
  var ref = _ref.ref,
      object = _ref.object;
  this.macroPeriod = void 0;
  this.macroPeriodValue = void 0;
  this.aggregate = void 0;
  this.aggregateValue = void 0;
  this.measuringPeriod = void 0;
  this.measuringPeriodValue = void 0;
  this.accumulation = void 0;
  this.accumulationValue = void 0;
  this.flowDirection = void 0;
  this.flowDirectionValue = void 0;
  this.commodity = void 0;
  this.commodityValue = void 0;
  this.measurementKind = void 0;
  this.measurementKindValue = void 0;
  this.interharmonicNumerator = void 0;
  this.interharmonicDenominator = void 0;
  this.interharmonic = void 0;
  this.argumentNumerator = void 0;
  this.argumentDenominator = void 0;
  this.argument = void 0;
  this.tou = void 0;
  this.touValue = void 0;
  this.cpp = void 0;
  this.cppValue = void 0;
  this.consumptionTier = void 0;
  this.consumptionTierValue = void 0;
  this.phases = void 0;
  this.phasesValue = void 0;
  this.multiplier = void 0;
  this.multiplierShort = void 0;
  this.multiplierValue = void 0;
  this.unit = void 0;
  this.unitValue = void 0;
  this.currency = void 0;
  this.currencyValue = void 0;
  var obj = ref ? createObject(ref, ['macroPeriod', 'aggregate', 'measuringPeriod', 'accumulation', 'flowDirection', 'commodity', 'measurementKind', 'interharmonicNumerator', 'interharmonicDenominator', 'argumentNumerator', 'argumentDenominator', 'tou', 'cpp', 'consumptionTier', 'phases', 'multiplier', 'unit', 'currency']) : object;
  this.macroPeriod = MacroPeriodCodes$1[obj.macroPeriod];
  this.macroPeriodValue = obj.macroPeriod;
  this.aggregate = AggregateCodes$1[obj.aggregate];
  this.aggregateValue = obj.aggregate;
  this.measuringPeriod = MeasuringPeriodCodes$1[obj.measuringPeriod];
  this.measuringPeriodValue = obj.measuringPeriod;
  this.accumulation = AccumulationCodes$1[obj.accumulation];
  this.accumulationValue = obj.accumulation;
  this.flowDirection = FlowDirectionCodes$1[obj.flowDirection];
  this.flowDirectionValue = obj.flowDirection;
  this.commodity = CommodityCodes$1[obj.commodity];
  this.commodityValue = obj.commodity;
  this.measurementKind = MeasurementKindCodes$1[obj.measurementKind];
  this.measurementKindValue = obj.measurementKind;
  this.interharmonicNumerator = obj.interharmonicNumerator;
  this.interharmonicDenominator = obj.interharmonicDenominator;
  this.interharmonic = readingTypeInterharmonic(obj.interharmonicNumerator, obj.interharmonicDenominator);
  this.argumentNumerator = obj.argumentNumerator;
  this.argumentDenominator = obj.argumentDenominator;
  this.argument = readingTypeArgument(obj.argumentNumerator, obj.argumentDenominator);
  this.tou = TimeOfUseCodes$1[obj.tou];
  this.touValue = obj.tou;
  this.cpp = CriticalPeakPeriodCodes$1[obj.cpp];
  this.cppValue = obj.cpp;
  this.consumptionTier = ConsumptionTierCodes$1[obj.consumptionTier];
  this.consumptionTierValue = obj.consumptionTier;
  this.phases = PhaseCodes$1[obj.phases];
  this.phasesValue = obj.phases;
  var multiplierObj = readingTypeMultiplier(obj.multiplier);
  this.multiplier = multiplierObj.value;
  this.multiplierShort = multiplierObj.symbol;
  this.multiplierValue = obj.multiplier;
  this.unit = UnitCodes$1[obj.unit];
  this.unitValue = obj.unit;
  this.currency = CurrencyCodes$1[obj.currency];
  this.currencyValue = obj.currency;
};

export { EndDeviceEventType, Codes$2 as EndDeviceEventTypeCodes, ReadingQuality, Codes$1 as ReadingQualityCodes, ReadingType, Codes as ReadingTypeCodes };
